import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, Inject, ContentChildren, Output } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, DxIntegrationModule, CollectionNestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { PROPERTY_TOKEN_validationRules, PROPERTY_TOKEN_buttons, PROPERTY_TOKEN_changes, PROPERTY_TOKEN_columns, PROPERTY_TOKEN_customOperations, PROPERTY_TOKEN_fields, PROPERTY_TOKEN_toolbarItems, PROPERTY_TOKEN_groupItems, PROPERTY_TOKEN_items, PROPERTY_TOKEN_sortByGroupSummaryInfo, PROPERTY_TOKEN_totalItems } from 'devextreme-angular/core/tokens';
import { DOCUMENT } from '@angular/common';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
let DxoDataGridAnimationComponent = /*#__PURE__*/(() => {
  class DxoDataGridAnimationComponent extends NestedOption {
    get hide() {
      return this._getOption('hide');
    }
    set hide(value) {
      this._setOption('hide', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get _optionPath() {
      return 'animation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridAnimationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridAnimationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridAnimationComponent,
      selectors: [["dxo-data-grid-animation"]],
      inputs: {
        hide: "hide",
        show: "show"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridAnimationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridAnimationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridAnimationModule = /*#__PURE__*/(() => {
  class DxoDataGridAnimationModule {
    /** @nocollapse */static ɵfac = function DxoDataGridAnimationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridAnimationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridAnimationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridAnimationComponent]
    });
  }
  return DxoDataGridAnimationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridAsyncRuleComponent = /*#__PURE__*/(() => {
  class DxiDataGridAsyncRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get reevaluate() {
      return this._getOption('reevaluate');
    }
    set reevaluate(value) {
      this._setOption('reevaluate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get validationCallback() {
      return this._getOption('validationCallback');
    }
    set validationCallback(value) {
      this._setOption('validationCallback', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'async';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridAsyncRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridAsyncRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridAsyncRuleComponent,
      selectors: [["dxi-data-grid-async-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        message: "message",
        reevaluate: "reevaluate",
        type: "type",
        validationCallback: "validationCallback"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiDataGridAsyncRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridAsyncRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridAsyncRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridAsyncRuleModule = /*#__PURE__*/(() => {
  class DxiDataGridAsyncRuleModule {
    /** @nocollapse */static ɵfac = function DxiDataGridAsyncRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridAsyncRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridAsyncRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridAsyncRuleComponent]
    });
  }
  return DxiDataGridAsyncRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridAtComponent = /*#__PURE__*/(() => {
  class DxoDataGridAtComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'at';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridAtComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridAtComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridAtComponent,
      selectors: [["dxo-data-grid-at"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridAtComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridAtComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridAtModule = /*#__PURE__*/(() => {
  class DxoDataGridAtModule {
    /** @nocollapse */static ɵfac = function DxoDataGridAtModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridAtModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridAtModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridAtComponent]
    });
  }
  return DxoDataGridAtModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridBoundaryOffsetComponent = /*#__PURE__*/(() => {
  class DxoDataGridBoundaryOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'boundaryOffset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridBoundaryOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridBoundaryOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridBoundaryOffsetComponent,
      selectors: [["dxo-data-grid-boundary-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridBoundaryOffsetComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridBoundaryOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridBoundaryOffsetModule = /*#__PURE__*/(() => {
  class DxoDataGridBoundaryOffsetModule {
    /** @nocollapse */static ɵfac = function DxoDataGridBoundaryOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridBoundaryOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridBoundaryOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridBoundaryOffsetComponent]
    });
  }
  return DxoDataGridBoundaryOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridButtonComponent = /*#__PURE__*/(() => {
  class DxiDataGridButtonComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get onClick() {
      return this._getOption('onClick');
    }
    set onClick(value) {
      this._setOption('onClick', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'buttons';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridButtonComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridButtonComponent,
      selectors: [["dxi-data-grid-button"]],
      inputs: {
        cssClass: "cssClass",
        disabled: "disabled",
        hint: "hint",
        icon: "icon",
        name: "name",
        onClick: "onClick",
        template: "template",
        text: "text",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_buttons,
        useExisting: DxiDataGridButtonComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiDataGridButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiDataGridButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridButtonModule = /*#__PURE__*/(() => {
  class DxiDataGridButtonModule {
    /** @nocollapse */static ɵfac = function DxiDataGridButtonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridButtonModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridButtonModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridButtonComponent]
    });
  }
  return DxiDataGridButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridChangeComponent = /*#__PURE__*/(() => {
  class DxiDataGridChangeComponent extends CollectionNestedOption {
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get insertAfterKey() {
      return this._getOption('insertAfterKey');
    }
    set insertAfterKey(value) {
      this._setOption('insertAfterKey', value);
    }
    get insertBeforeKey() {
      return this._getOption('insertBeforeKey');
    }
    set insertBeforeKey(value) {
      this._setOption('insertBeforeKey', value);
    }
    get key() {
      return this._getOption('key');
    }
    set key(value) {
      this._setOption('key', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'changes';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridChangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridChangeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridChangeComponent,
      selectors: [["dxi-data-grid-change"]],
      inputs: {
        data: "data",
        insertAfterKey: "insertAfterKey",
        insertBeforeKey: "insertBeforeKey",
        key: "key",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_changes,
        useExisting: DxiDataGridChangeComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridChangeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridChangeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridChangeModule = /*#__PURE__*/(() => {
  class DxiDataGridChangeModule {
    /** @nocollapse */static ɵfac = function DxiDataGridChangeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridChangeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridChangeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridChangeComponent]
    });
  }
  return DxiDataGridChangeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridColCountByScreenComponent = /*#__PURE__*/(() => {
  class DxoDataGridColCountByScreenComponent extends NestedOption {
    get lg() {
      return this._getOption('lg');
    }
    set lg(value) {
      this._setOption('lg', value);
    }
    get md() {
      return this._getOption('md');
    }
    set md(value) {
      this._setOption('md', value);
    }
    get sm() {
      return this._getOption('sm');
    }
    set sm(value) {
      this._setOption('sm', value);
    }
    get xs() {
      return this._getOption('xs');
    }
    set xs(value) {
      this._setOption('xs', value);
    }
    get _optionPath() {
      return 'colCountByScreen';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridColCountByScreenComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColCountByScreenComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridColCountByScreenComponent,
      selectors: [["dxo-data-grid-col-count-by-screen"]],
      inputs: {
        lg: "lg",
        md: "md",
        sm: "sm",
        xs: "xs"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridColCountByScreenComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridColCountByScreenComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridColCountByScreenModule = /*#__PURE__*/(() => {
  class DxoDataGridColCountByScreenModule {
    /** @nocollapse */static ɵfac = function DxoDataGridColCountByScreenModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColCountByScreenModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridColCountByScreenModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridColCountByScreenComponent]
    });
  }
  return DxoDataGridColCountByScreenModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridCollisionComponent = /*#__PURE__*/(() => {
  class DxoDataGridCollisionComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'collision';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridCollisionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridCollisionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridCollisionComponent,
      selectors: [["dxo-data-grid-collision"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridCollisionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridCollisionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridCollisionModule = /*#__PURE__*/(() => {
  class DxoDataGridCollisionModule {
    /** @nocollapse */static ɵfac = function DxoDataGridCollisionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridCollisionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridCollisionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridCollisionComponent]
    });
  }
  return DxoDataGridCollisionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridColumnChooserSearchComponent = /*#__PURE__*/(() => {
  class DxoDataGridColumnChooserSearchComponent extends NestedOption {
    get editorOptions() {
      return this._getOption('editorOptions');
    }
    set editorOptions(value) {
      this._setOption('editorOptions', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get timeout() {
      return this._getOption('timeout');
    }
    set timeout(value) {
      this._setOption('timeout', value);
    }
    get _optionPath() {
      return 'search';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridColumnChooserSearchComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnChooserSearchComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridColumnChooserSearchComponent,
      selectors: [["dxo-data-grid-column-chooser-search"]],
      inputs: {
        editorOptions: "editorOptions",
        enabled: "enabled",
        timeout: "timeout"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridColumnChooserSearchComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridColumnChooserSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridColumnChooserSearchModule = /*#__PURE__*/(() => {
  class DxoDataGridColumnChooserSearchModule {
    /** @nocollapse */static ɵfac = function DxoDataGridColumnChooserSearchModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnChooserSearchModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridColumnChooserSearchModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridColumnChooserSearchComponent]
    });
  }
  return DxoDataGridColumnChooserSearchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridColumnChooserSelectionComponent = /*#__PURE__*/(() => {
  class DxoDataGridColumnChooserSelectionComponent extends NestedOption {
    get allowSelectAll() {
      return this._getOption('allowSelectAll');
    }
    set allowSelectAll(value) {
      this._setOption('allowSelectAll', value);
    }
    get recursive() {
      return this._getOption('recursive');
    }
    set recursive(value) {
      this._setOption('recursive', value);
    }
    get selectByClick() {
      return this._getOption('selectByClick');
    }
    set selectByClick(value) {
      this._setOption('selectByClick', value);
    }
    get _optionPath() {
      return 'selection';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridColumnChooserSelectionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnChooserSelectionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridColumnChooserSelectionComponent,
      selectors: [["dxo-data-grid-column-chooser-selection"]],
      inputs: {
        allowSelectAll: "allowSelectAll",
        recursive: "recursive",
        selectByClick: "selectByClick"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridColumnChooserSelectionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridColumnChooserSelectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridColumnChooserSelectionModule = /*#__PURE__*/(() => {
  class DxoDataGridColumnChooserSelectionModule {
    /** @nocollapse */static ɵfac = function DxoDataGridColumnChooserSelectionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnChooserSelectionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridColumnChooserSelectionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridColumnChooserSelectionComponent]
    });
  }
  return DxoDataGridColumnChooserSelectionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridColumnChooserComponent = /*#__PURE__*/(() => {
  class DxoDataGridColumnChooserComponent extends NestedOption {
    get allowSearch() {
      return this._getOption('allowSearch');
    }
    set allowSearch(value) {
      this._setOption('allowSearch', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get emptyPanelText() {
      return this._getOption('emptyPanelText');
    }
    set emptyPanelText(value) {
      this._setOption('emptyPanelText', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get search() {
      return this._getOption('search');
    }
    set search(value) {
      this._setOption('search', value);
    }
    get searchTimeout() {
      return this._getOption('searchTimeout');
    }
    set searchTimeout(value) {
      this._setOption('searchTimeout', value);
    }
    get selection() {
      return this._getOption('selection');
    }
    set selection(value) {
      this._setOption('selection', value);
    }
    get sortOrder() {
      return this._getOption('sortOrder');
    }
    set sortOrder(value) {
      this._setOption('sortOrder', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'columnChooser';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridColumnChooserComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnChooserComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridColumnChooserComponent,
      selectors: [["dxo-data-grid-column-chooser"]],
      inputs: {
        allowSearch: "allowSearch",
        container: "container",
        emptyPanelText: "emptyPanelText",
        enabled: "enabled",
        height: "height",
        mode: "mode",
        position: "position",
        search: "search",
        searchTimeout: "searchTimeout",
        selection: "selection",
        sortOrder: "sortOrder",
        title: "title",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridColumnChooserComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridColumnChooserComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridColumnChooserModule = /*#__PURE__*/(() => {
  class DxoDataGridColumnChooserModule {
    /** @nocollapse */static ɵfac = function DxoDataGridColumnChooserModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnChooserModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridColumnChooserModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridColumnChooserComponent]
    });
  }
  return DxoDataGridColumnChooserModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridColumnComponent = /*#__PURE__*/(() => {
  class DxiDataGridColumnComponent extends CollectionNestedOption {
    set _validationRulesContentChildren(value) {
      this.setChildren('validationRules', value);
    }
    set _buttonsContentChildren(value) {
      this.setChildren('buttons', value);
    }
    set _columnsContentChildren(value) {
      this.setChildren('columns', value);
    }
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get allowEditing() {
      return this._getOption('allowEditing');
    }
    set allowEditing(value) {
      this._setOption('allowEditing', value);
    }
    get allowExporting() {
      return this._getOption('allowExporting');
    }
    set allowExporting(value) {
      this._setOption('allowExporting', value);
    }
    get allowFiltering() {
      return this._getOption('allowFiltering');
    }
    set allowFiltering(value) {
      this._setOption('allowFiltering', value);
    }
    get allowFixing() {
      return this._getOption('allowFixing');
    }
    set allowFixing(value) {
      this._setOption('allowFixing', value);
    }
    get allowGrouping() {
      return this._getOption('allowGrouping');
    }
    set allowGrouping(value) {
      this._setOption('allowGrouping', value);
    }
    get allowHeaderFiltering() {
      return this._getOption('allowHeaderFiltering');
    }
    set allowHeaderFiltering(value) {
      this._setOption('allowHeaderFiltering', value);
    }
    get allowHiding() {
      return this._getOption('allowHiding');
    }
    set allowHiding(value) {
      this._setOption('allowHiding', value);
    }
    get allowReordering() {
      return this._getOption('allowReordering');
    }
    set allowReordering(value) {
      this._setOption('allowReordering', value);
    }
    get allowResizing() {
      return this._getOption('allowResizing');
    }
    set allowResizing(value) {
      this._setOption('allowResizing', value);
    }
    get allowSearch() {
      return this._getOption('allowSearch');
    }
    set allowSearch(value) {
      this._setOption('allowSearch', value);
    }
    get allowSorting() {
      return this._getOption('allowSorting');
    }
    set allowSorting(value) {
      this._setOption('allowSorting', value);
    }
    get autoExpandGroup() {
      return this._getOption('autoExpandGroup');
    }
    set autoExpandGroup(value) {
      this._setOption('autoExpandGroup', value);
    }
    get buttons() {
      return this._getOption('buttons');
    }
    set buttons(value) {
      this._setOption('buttons', value);
    }
    get calculateCellValue() {
      return this._getOption('calculateCellValue');
    }
    set calculateCellValue(value) {
      this._setOption('calculateCellValue', value);
    }
    get calculateDisplayValue() {
      return this._getOption('calculateDisplayValue');
    }
    set calculateDisplayValue(value) {
      this._setOption('calculateDisplayValue', value);
    }
    get calculateFilterExpression() {
      return this._getOption('calculateFilterExpression');
    }
    set calculateFilterExpression(value) {
      this._setOption('calculateFilterExpression', value);
    }
    get calculateGroupValue() {
      return this._getOption('calculateGroupValue');
    }
    set calculateGroupValue(value) {
      this._setOption('calculateGroupValue', value);
    }
    get calculateSortValue() {
      return this._getOption('calculateSortValue');
    }
    set calculateSortValue(value) {
      this._setOption('calculateSortValue', value);
    }
    get caption() {
      return this._getOption('caption');
    }
    set caption(value) {
      this._setOption('caption', value);
    }
    get cellTemplate() {
      return this._getOption('cellTemplate');
    }
    set cellTemplate(value) {
      this._setOption('cellTemplate', value);
    }
    get columns() {
      return this._getOption('columns');
    }
    set columns(value) {
      this._setOption('columns', value);
    }
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get dataField() {
      return this._getOption('dataField');
    }
    set dataField(value) {
      this._setOption('dataField', value);
    }
    get dataType() {
      return this._getOption('dataType');
    }
    set dataType(value) {
      this._setOption('dataType', value);
    }
    get editCellTemplate() {
      return this._getOption('editCellTemplate');
    }
    set editCellTemplate(value) {
      this._setOption('editCellTemplate', value);
    }
    get editorOptions() {
      return this._getOption('editorOptions');
    }
    set editorOptions(value) {
      this._setOption('editorOptions', value);
    }
    get encodeHtml() {
      return this._getOption('encodeHtml');
    }
    set encodeHtml(value) {
      this._setOption('encodeHtml', value);
    }
    get falseText() {
      return this._getOption('falseText');
    }
    set falseText(value) {
      this._setOption('falseText', value);
    }
    get filterOperations() {
      return this._getOption('filterOperations');
    }
    set filterOperations(value) {
      this._setOption('filterOperations', value);
    }
    get filterType() {
      return this._getOption('filterType');
    }
    set filterType(value) {
      this._setOption('filterType', value);
    }
    get filterValue() {
      return this._getOption('filterValue');
    }
    set filterValue(value) {
      this._setOption('filterValue', value);
    }
    get filterValues() {
      return this._getOption('filterValues');
    }
    set filterValues(value) {
      this._setOption('filterValues', value);
    }
    get fixed() {
      return this._getOption('fixed');
    }
    set fixed(value) {
      this._setOption('fixed', value);
    }
    get fixedPosition() {
      return this._getOption('fixedPosition');
    }
    set fixedPosition(value) {
      this._setOption('fixedPosition', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get formItem() {
      return this._getOption('formItem');
    }
    set formItem(value) {
      this._setOption('formItem', value);
    }
    get groupCellTemplate() {
      return this._getOption('groupCellTemplate');
    }
    set groupCellTemplate(value) {
      this._setOption('groupCellTemplate', value);
    }
    get groupIndex() {
      return this._getOption('groupIndex');
    }
    set groupIndex(value) {
      this._setOption('groupIndex', value);
    }
    get headerCellTemplate() {
      return this._getOption('headerCellTemplate');
    }
    set headerCellTemplate(value) {
      this._setOption('headerCellTemplate', value);
    }
    get headerFilter() {
      return this._getOption('headerFilter');
    }
    set headerFilter(value) {
      this._setOption('headerFilter', value);
    }
    get hidingPriority() {
      return this._getOption('hidingPriority');
    }
    set hidingPriority(value) {
      this._setOption('hidingPriority', value);
    }
    get isBand() {
      return this._getOption('isBand');
    }
    set isBand(value) {
      this._setOption('isBand', value);
    }
    get lookup() {
      return this._getOption('lookup');
    }
    set lookup(value) {
      this._setOption('lookup', value);
    }
    get minWidth() {
      return this._getOption('minWidth');
    }
    set minWidth(value) {
      this._setOption('minWidth', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get ownerBand() {
      return this._getOption('ownerBand');
    }
    set ownerBand(value) {
      this._setOption('ownerBand', value);
    }
    get renderAsync() {
      return this._getOption('renderAsync');
    }
    set renderAsync(value) {
      this._setOption('renderAsync', value);
    }
    get selectedFilterOperation() {
      return this._getOption('selectedFilterOperation');
    }
    set selectedFilterOperation(value) {
      this._setOption('selectedFilterOperation', value);
    }
    get setCellValue() {
      return this._getOption('setCellValue');
    }
    set setCellValue(value) {
      this._setOption('setCellValue', value);
    }
    get showEditorAlways() {
      return this._getOption('showEditorAlways');
    }
    set showEditorAlways(value) {
      this._setOption('showEditorAlways', value);
    }
    get showInColumnChooser() {
      return this._getOption('showInColumnChooser');
    }
    set showInColumnChooser(value) {
      this._setOption('showInColumnChooser', value);
    }
    get showWhenGrouped() {
      return this._getOption('showWhenGrouped');
    }
    set showWhenGrouped(value) {
      this._setOption('showWhenGrouped', value);
    }
    get sortIndex() {
      return this._getOption('sortIndex');
    }
    set sortIndex(value) {
      this._setOption('sortIndex', value);
    }
    get sortingMethod() {
      return this._getOption('sortingMethod');
    }
    set sortingMethod(value) {
      this._setOption('sortingMethod', value);
    }
    get sortOrder() {
      return this._getOption('sortOrder');
    }
    set sortOrder(value) {
      this._setOption('sortOrder', value);
    }
    get trueText() {
      return this._getOption('trueText');
    }
    set trueText(value) {
      this._setOption('trueText', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get validationRules() {
      return this._getOption('validationRules');
    }
    set validationRules(value) {
      this._setOption('validationRules', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get visibleIndex() {
      return this._getOption('visibleIndex');
    }
    set visibleIndex(value) {
      this._setOption('visibleIndex', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    filterValueChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    filterValuesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    groupIndexChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    selectedFilterOperationChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    sortIndexChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    sortOrderChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleIndexChange;
    get _optionPath() {
      return 'columns';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'filterValueChange'
      }, {
        emit: 'filterValuesChange'
      }, {
        emit: 'groupIndexChange'
      }, {
        emit: 'selectedFilterOperationChange'
      }, {
        emit: 'sortIndexChange'
      }, {
        emit: 'sortOrderChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'visibleIndexChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridColumnComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridColumnComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridColumnComponent,
      selectors: [["dxi-data-grid-column"]],
      contentQueries: function DxiDataGridColumnComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_validationRules, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_buttons, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_columns, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._validationRulesContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._buttonsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._columnsContentChildren = _t);
        }
      },
      inputs: {
        alignment: "alignment",
        allowEditing: "allowEditing",
        allowExporting: "allowExporting",
        allowFiltering: "allowFiltering",
        allowFixing: "allowFixing",
        allowGrouping: "allowGrouping",
        allowHeaderFiltering: "allowHeaderFiltering",
        allowHiding: "allowHiding",
        allowReordering: "allowReordering",
        allowResizing: "allowResizing",
        allowSearch: "allowSearch",
        allowSorting: "allowSorting",
        autoExpandGroup: "autoExpandGroup",
        buttons: "buttons",
        calculateCellValue: "calculateCellValue",
        calculateDisplayValue: "calculateDisplayValue",
        calculateFilterExpression: "calculateFilterExpression",
        calculateGroupValue: "calculateGroupValue",
        calculateSortValue: "calculateSortValue",
        caption: "caption",
        cellTemplate: "cellTemplate",
        columns: "columns",
        cssClass: "cssClass",
        customizeText: "customizeText",
        dataField: "dataField",
        dataType: "dataType",
        editCellTemplate: "editCellTemplate",
        editorOptions: "editorOptions",
        encodeHtml: "encodeHtml",
        falseText: "falseText",
        filterOperations: "filterOperations",
        filterType: "filterType",
        filterValue: "filterValue",
        filterValues: "filterValues",
        fixed: "fixed",
        fixedPosition: "fixedPosition",
        format: "format",
        formItem: "formItem",
        groupCellTemplate: "groupCellTemplate",
        groupIndex: "groupIndex",
        headerCellTemplate: "headerCellTemplate",
        headerFilter: "headerFilter",
        hidingPriority: "hidingPriority",
        isBand: "isBand",
        lookup: "lookup",
        minWidth: "minWidth",
        name: "name",
        ownerBand: "ownerBand",
        renderAsync: "renderAsync",
        selectedFilterOperation: "selectedFilterOperation",
        setCellValue: "setCellValue",
        showEditorAlways: "showEditorAlways",
        showInColumnChooser: "showInColumnChooser",
        showWhenGrouped: "showWhenGrouped",
        sortIndex: "sortIndex",
        sortingMethod: "sortingMethod",
        sortOrder: "sortOrder",
        trueText: "trueText",
        type: "type",
        validationRules: "validationRules",
        visible: "visible",
        visibleIndex: "visibleIndex",
        width: "width"
      },
      outputs: {
        filterValueChange: "filterValueChange",
        filterValuesChange: "filterValuesChange",
        groupIndexChange: "groupIndexChange",
        selectedFilterOperationChange: "selectedFilterOperationChange",
        sortIndexChange: "sortIndexChange",
        sortOrderChange: "sortOrderChange",
        visibleChange: "visibleChange",
        visibleIndexChange: "visibleIndexChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_columns,
        useExisting: DxiDataGridColumnComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridColumnComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridColumnComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridColumnModule = /*#__PURE__*/(() => {
  class DxiDataGridColumnModule {
    /** @nocollapse */static ɵfac = function DxiDataGridColumnModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridColumnModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridColumnModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridColumnComponent]
    });
  }
  return DxiDataGridColumnModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridColumnFixingTextsComponent = /*#__PURE__*/(() => {
  class DxoDataGridColumnFixingTextsComponent extends NestedOption {
    get fix() {
      return this._getOption('fix');
    }
    set fix(value) {
      this._setOption('fix', value);
    }
    get leftPosition() {
      return this._getOption('leftPosition');
    }
    set leftPosition(value) {
      this._setOption('leftPosition', value);
    }
    get rightPosition() {
      return this._getOption('rightPosition');
    }
    set rightPosition(value) {
      this._setOption('rightPosition', value);
    }
    get stickyPosition() {
      return this._getOption('stickyPosition');
    }
    set stickyPosition(value) {
      this._setOption('stickyPosition', value);
    }
    get unfix() {
      return this._getOption('unfix');
    }
    set unfix(value) {
      this._setOption('unfix', value);
    }
    get _optionPath() {
      return 'texts';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridColumnFixingTextsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnFixingTextsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridColumnFixingTextsComponent,
      selectors: [["dxo-data-grid-column-fixing-texts"]],
      inputs: {
        fix: "fix",
        leftPosition: "leftPosition",
        rightPosition: "rightPosition",
        stickyPosition: "stickyPosition",
        unfix: "unfix"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridColumnFixingTextsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridColumnFixingTextsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridColumnFixingTextsModule = /*#__PURE__*/(() => {
  class DxoDataGridColumnFixingTextsModule {
    /** @nocollapse */static ɵfac = function DxoDataGridColumnFixingTextsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnFixingTextsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridColumnFixingTextsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridColumnFixingTextsComponent]
    });
  }
  return DxoDataGridColumnFixingTextsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridColumnFixingComponent = /*#__PURE__*/(() => {
  class DxoDataGridColumnFixingComponent extends NestedOption {
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get icons() {
      return this._getOption('icons');
    }
    set icons(value) {
      this._setOption('icons', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get _optionPath() {
      return 'columnFixing';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridColumnFixingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnFixingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridColumnFixingComponent,
      selectors: [["dxo-data-grid-column-fixing"]],
      inputs: {
        enabled: "enabled",
        icons: "icons",
        texts: "texts"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridColumnFixingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridColumnFixingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridColumnFixingModule = /*#__PURE__*/(() => {
  class DxoDataGridColumnFixingModule {
    /** @nocollapse */static ɵfac = function DxoDataGridColumnFixingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnFixingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridColumnFixingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridColumnFixingComponent]
    });
  }
  return DxoDataGridColumnFixingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridColumnHeaderFilterSearchComponent = /*#__PURE__*/(() => {
  class DxoDataGridColumnHeaderFilterSearchComponent extends NestedOption {
    get editorOptions() {
      return this._getOption('editorOptions');
    }
    set editorOptions(value) {
      this._setOption('editorOptions', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get searchExpr() {
      return this._getOption('searchExpr');
    }
    set searchExpr(value) {
      this._setOption('searchExpr', value);
    }
    get timeout() {
      return this._getOption('timeout');
    }
    set timeout(value) {
      this._setOption('timeout', value);
    }
    get _optionPath() {
      return 'search';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridColumnHeaderFilterSearchComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnHeaderFilterSearchComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridColumnHeaderFilterSearchComponent,
      selectors: [["dxo-data-grid-column-header-filter-search"]],
      inputs: {
        editorOptions: "editorOptions",
        enabled: "enabled",
        mode: "mode",
        searchExpr: "searchExpr",
        timeout: "timeout"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridColumnHeaderFilterSearchComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridColumnHeaderFilterSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridColumnHeaderFilterSearchModule = /*#__PURE__*/(() => {
  class DxoDataGridColumnHeaderFilterSearchModule {
    /** @nocollapse */static ɵfac = function DxoDataGridColumnHeaderFilterSearchModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnHeaderFilterSearchModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridColumnHeaderFilterSearchModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridColumnHeaderFilterSearchComponent]
    });
  }
  return DxoDataGridColumnHeaderFilterSearchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridColumnHeaderFilterComponent = /*#__PURE__*/(() => {
  class DxoDataGridColumnHeaderFilterComponent extends NestedOption {
    get allowSearch() {
      return this._getOption('allowSearch');
    }
    set allowSearch(value) {
      this._setOption('allowSearch', value);
    }
    get allowSelectAll() {
      return this._getOption('allowSelectAll');
    }
    set allowSelectAll(value) {
      this._setOption('allowSelectAll', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get groupInterval() {
      return this._getOption('groupInterval');
    }
    set groupInterval(value) {
      this._setOption('groupInterval', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get search() {
      return this._getOption('search');
    }
    set search(value) {
      this._setOption('search', value);
    }
    get searchMode() {
      return this._getOption('searchMode');
    }
    set searchMode(value) {
      this._setOption('searchMode', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'headerFilter';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridColumnHeaderFilterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnHeaderFilterComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridColumnHeaderFilterComponent,
      selectors: [["dxo-data-grid-column-header-filter"]],
      inputs: {
        allowSearch: "allowSearch",
        allowSelectAll: "allowSelectAll",
        dataSource: "dataSource",
        groupInterval: "groupInterval",
        height: "height",
        search: "search",
        searchMode: "searchMode",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridColumnHeaderFilterComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridColumnHeaderFilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridColumnHeaderFilterModule = /*#__PURE__*/(() => {
  class DxoDataGridColumnHeaderFilterModule {
    /** @nocollapse */static ɵfac = function DxoDataGridColumnHeaderFilterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnHeaderFilterModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridColumnHeaderFilterModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridColumnHeaderFilterComponent]
    });
  }
  return DxoDataGridColumnHeaderFilterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridColumnLookupComponent = /*#__PURE__*/(() => {
  class DxoDataGridColumnLookupComponent extends NestedOption {
    get allowClearing() {
      return this._getOption('allowClearing');
    }
    set allowClearing(value) {
      this._setOption('allowClearing', value);
    }
    get calculateCellValue() {
      return this._getOption('calculateCellValue');
    }
    set calculateCellValue(value) {
      this._setOption('calculateCellValue', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get displayExpr() {
      return this._getOption('displayExpr');
    }
    set displayExpr(value) {
      this._setOption('displayExpr', value);
    }
    get valueExpr() {
      return this._getOption('valueExpr');
    }
    set valueExpr(value) {
      this._setOption('valueExpr', value);
    }
    get _optionPath() {
      return 'lookup';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridColumnLookupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnLookupComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridColumnLookupComponent,
      selectors: [["dxo-data-grid-column-lookup"]],
      inputs: {
        allowClearing: "allowClearing",
        calculateCellValue: "calculateCellValue",
        dataSource: "dataSource",
        displayExpr: "displayExpr",
        valueExpr: "valueExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridColumnLookupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridColumnLookupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridColumnLookupModule = /*#__PURE__*/(() => {
  class DxoDataGridColumnLookupModule {
    /** @nocollapse */static ɵfac = function DxoDataGridColumnLookupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridColumnLookupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridColumnLookupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridColumnLookupComponent]
    });
  }
  return DxoDataGridColumnLookupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridCompareRuleComponent = /*#__PURE__*/(() => {
  class DxiDataGridCompareRuleComponent extends CollectionNestedOption {
    get comparisonTarget() {
      return this._getOption('comparisonTarget');
    }
    set comparisonTarget(value) {
      this._setOption('comparisonTarget', value);
    }
    get comparisonType() {
      return this._getOption('comparisonType');
    }
    set comparisonType(value) {
      this._setOption('comparisonType', value);
    }
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'compare';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridCompareRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridCompareRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridCompareRuleComponent,
      selectors: [["dxi-data-grid-compare-rule"]],
      inputs: {
        comparisonTarget: "comparisonTarget",
        comparisonType: "comparisonType",
        ignoreEmptyValue: "ignoreEmptyValue",
        message: "message",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiDataGridCompareRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridCompareRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridCompareRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridCompareRuleModule = /*#__PURE__*/(() => {
  class DxiDataGridCompareRuleModule {
    /** @nocollapse */static ɵfac = function DxiDataGridCompareRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridCompareRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridCompareRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridCompareRuleComponent]
    });
  }
  return DxiDataGridCompareRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridCursorOffsetComponent = /*#__PURE__*/(() => {
  class DxoDataGridCursorOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'cursorOffset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridCursorOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridCursorOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridCursorOffsetComponent,
      selectors: [["dxo-data-grid-cursor-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridCursorOffsetComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridCursorOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridCursorOffsetModule = /*#__PURE__*/(() => {
  class DxoDataGridCursorOffsetModule {
    /** @nocollapse */static ɵfac = function DxoDataGridCursorOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridCursorOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridCursorOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridCursorOffsetComponent]
    });
  }
  return DxoDataGridCursorOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridCustomOperationComponent = /*#__PURE__*/(() => {
  class DxiDataGridCustomOperationComponent extends CollectionNestedOption {
    get calculateFilterExpression() {
      return this._getOption('calculateFilterExpression');
    }
    set calculateFilterExpression(value) {
      this._setOption('calculateFilterExpression', value);
    }
    get caption() {
      return this._getOption('caption');
    }
    set caption(value) {
      this._setOption('caption', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get dataTypes() {
      return this._getOption('dataTypes');
    }
    set dataTypes(value) {
      this._setOption('dataTypes', value);
    }
    get editorTemplate() {
      return this._getOption('editorTemplate');
    }
    set editorTemplate(value) {
      this._setOption('editorTemplate', value);
    }
    get hasValue() {
      return this._getOption('hasValue');
    }
    set hasValue(value) {
      this._setOption('hasValue', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get _optionPath() {
      return 'customOperations';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridCustomOperationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridCustomOperationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridCustomOperationComponent,
      selectors: [["dxi-data-grid-custom-operation"]],
      inputs: {
        calculateFilterExpression: "calculateFilterExpression",
        caption: "caption",
        customizeText: "customizeText",
        dataTypes: "dataTypes",
        editorTemplate: "editorTemplate",
        hasValue: "hasValue",
        icon: "icon",
        name: "name"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_customOperations,
        useExisting: DxiDataGridCustomOperationComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridCustomOperationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridCustomOperationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridCustomOperationModule = /*#__PURE__*/(() => {
  class DxiDataGridCustomOperationModule {
    /** @nocollapse */static ɵfac = function DxiDataGridCustomOperationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridCustomOperationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridCustomOperationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridCustomOperationComponent]
    });
  }
  return DxiDataGridCustomOperationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridCustomRuleComponent = /*#__PURE__*/(() => {
  class DxiDataGridCustomRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get reevaluate() {
      return this._getOption('reevaluate');
    }
    set reevaluate(value) {
      this._setOption('reevaluate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get validationCallback() {
      return this._getOption('validationCallback');
    }
    set validationCallback(value) {
      this._setOption('validationCallback', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'custom';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridCustomRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridCustomRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridCustomRuleComponent,
      selectors: [["dxi-data-grid-custom-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        message: "message",
        reevaluate: "reevaluate",
        type: "type",
        validationCallback: "validationCallback"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiDataGridCustomRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridCustomRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridCustomRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridCustomRuleModule = /*#__PURE__*/(() => {
  class DxiDataGridCustomRuleModule {
    /** @nocollapse */static ɵfac = function DxiDataGridCustomRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridCustomRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridCustomRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridCustomRuleComponent]
    });
  }
  return DxiDataGridCustomRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridDataGridHeaderFilterSearchComponent = /*#__PURE__*/(() => {
  class DxoDataGridDataGridHeaderFilterSearchComponent extends NestedOption {
    get editorOptions() {
      return this._getOption('editorOptions');
    }
    set editorOptions(value) {
      this._setOption('editorOptions', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get timeout() {
      return this._getOption('timeout');
    }
    set timeout(value) {
      this._setOption('timeout', value);
    }
    get _optionPath() {
      return 'search';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridDataGridHeaderFilterSearchComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridDataGridHeaderFilterSearchComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridDataGridHeaderFilterSearchComponent,
      selectors: [["dxo-data-grid-data-grid-header-filter-search"]],
      inputs: {
        editorOptions: "editorOptions",
        enabled: "enabled",
        mode: "mode",
        timeout: "timeout"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridDataGridHeaderFilterSearchComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridDataGridHeaderFilterSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridDataGridHeaderFilterSearchModule = /*#__PURE__*/(() => {
  class DxoDataGridDataGridHeaderFilterSearchModule {
    /** @nocollapse */static ɵfac = function DxoDataGridDataGridHeaderFilterSearchModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridDataGridHeaderFilterSearchModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridDataGridHeaderFilterSearchModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridDataGridHeaderFilterSearchComponent]
    });
  }
  return DxoDataGridDataGridHeaderFilterSearchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridDataGridHeaderFilterTextsComponent = /*#__PURE__*/(() => {
  class DxoDataGridDataGridHeaderFilterTextsComponent extends NestedOption {
    get cancel() {
      return this._getOption('cancel');
    }
    set cancel(value) {
      this._setOption('cancel', value);
    }
    get emptyValue() {
      return this._getOption('emptyValue');
    }
    set emptyValue(value) {
      this._setOption('emptyValue', value);
    }
    get ok() {
      return this._getOption('ok');
    }
    set ok(value) {
      this._setOption('ok', value);
    }
    get _optionPath() {
      return 'texts';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridDataGridHeaderFilterTextsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridDataGridHeaderFilterTextsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridDataGridHeaderFilterTextsComponent,
      selectors: [["dxo-data-grid-data-grid-header-filter-texts"]],
      inputs: {
        cancel: "cancel",
        emptyValue: "emptyValue",
        ok: "ok"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridDataGridHeaderFilterTextsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridDataGridHeaderFilterTextsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridDataGridHeaderFilterTextsModule = /*#__PURE__*/(() => {
  class DxoDataGridDataGridHeaderFilterTextsModule {
    /** @nocollapse */static ɵfac = function DxoDataGridDataGridHeaderFilterTextsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridDataGridHeaderFilterTextsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridDataGridHeaderFilterTextsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridDataGridHeaderFilterTextsComponent]
    });
  }
  return DxoDataGridDataGridHeaderFilterTextsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridDataGridHeaderFilterComponent = /*#__PURE__*/(() => {
  class DxoDataGridDataGridHeaderFilterComponent extends NestedOption {
    get allowSearch() {
      return this._getOption('allowSearch');
    }
    set allowSearch(value) {
      this._setOption('allowSearch', value);
    }
    get allowSelectAll() {
      return this._getOption('allowSelectAll');
    }
    set allowSelectAll(value) {
      this._setOption('allowSelectAll', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get search() {
      return this._getOption('search');
    }
    set search(value) {
      this._setOption('search', value);
    }
    get searchTimeout() {
      return this._getOption('searchTimeout');
    }
    set searchTimeout(value) {
      this._setOption('searchTimeout', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'headerFilter';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridDataGridHeaderFilterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridDataGridHeaderFilterComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridDataGridHeaderFilterComponent,
      selectors: [["dxo-data-grid-data-grid-header-filter"]],
      inputs: {
        allowSearch: "allowSearch",
        allowSelectAll: "allowSelectAll",
        height: "height",
        search: "search",
        searchTimeout: "searchTimeout",
        texts: "texts",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridDataGridHeaderFilterComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridDataGridHeaderFilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridDataGridHeaderFilterModule = /*#__PURE__*/(() => {
  class DxoDataGridDataGridHeaderFilterModule {
    /** @nocollapse */static ɵfac = function DxoDataGridDataGridHeaderFilterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridDataGridHeaderFilterModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridDataGridHeaderFilterModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridDataGridHeaderFilterComponent]
    });
  }
  return DxoDataGridDataGridHeaderFilterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridDataGridSelectionComponent = /*#__PURE__*/(() => {
  class DxoDataGridDataGridSelectionComponent extends NestedOption {
    get allowSelectAll() {
      return this._getOption('allowSelectAll');
    }
    set allowSelectAll(value) {
      this._setOption('allowSelectAll', value);
    }
    get deferred() {
      return this._getOption('deferred');
    }
    set deferred(value) {
      this._setOption('deferred', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get selectAllMode() {
      return this._getOption('selectAllMode');
    }
    set selectAllMode(value) {
      this._setOption('selectAllMode', value);
    }
    get sensitivity() {
      return this._getOption('sensitivity');
    }
    set sensitivity(value) {
      this._setOption('sensitivity', value);
    }
    get showCheckBoxesMode() {
      return this._getOption('showCheckBoxesMode');
    }
    set showCheckBoxesMode(value) {
      this._setOption('showCheckBoxesMode', value);
    }
    get _optionPath() {
      return 'selection';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridDataGridSelectionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridDataGridSelectionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridDataGridSelectionComponent,
      selectors: [["dxo-data-grid-data-grid-selection"]],
      inputs: {
        allowSelectAll: "allowSelectAll",
        deferred: "deferred",
        mode: "mode",
        selectAllMode: "selectAllMode",
        sensitivity: "sensitivity",
        showCheckBoxesMode: "showCheckBoxesMode"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridDataGridSelectionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridDataGridSelectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridDataGridSelectionModule = /*#__PURE__*/(() => {
  class DxoDataGridDataGridSelectionModule {
    /** @nocollapse */static ɵfac = function DxoDataGridDataGridSelectionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridDataGridSelectionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridDataGridSelectionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridDataGridSelectionComponent]
    });
  }
  return DxoDataGridDataGridSelectionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridEditingTextsComponent = /*#__PURE__*/(() => {
  class DxoDataGridEditingTextsComponent extends NestedOption {
    get addRow() {
      return this._getOption('addRow');
    }
    set addRow(value) {
      this._setOption('addRow', value);
    }
    get cancelAllChanges() {
      return this._getOption('cancelAllChanges');
    }
    set cancelAllChanges(value) {
      this._setOption('cancelAllChanges', value);
    }
    get cancelRowChanges() {
      return this._getOption('cancelRowChanges');
    }
    set cancelRowChanges(value) {
      this._setOption('cancelRowChanges', value);
    }
    get confirmDeleteMessage() {
      return this._getOption('confirmDeleteMessage');
    }
    set confirmDeleteMessage(value) {
      this._setOption('confirmDeleteMessage', value);
    }
    get confirmDeleteTitle() {
      return this._getOption('confirmDeleteTitle');
    }
    set confirmDeleteTitle(value) {
      this._setOption('confirmDeleteTitle', value);
    }
    get deleteRow() {
      return this._getOption('deleteRow');
    }
    set deleteRow(value) {
      this._setOption('deleteRow', value);
    }
    get editRow() {
      return this._getOption('editRow');
    }
    set editRow(value) {
      this._setOption('editRow', value);
    }
    get saveAllChanges() {
      return this._getOption('saveAllChanges');
    }
    set saveAllChanges(value) {
      this._setOption('saveAllChanges', value);
    }
    get saveRowChanges() {
      return this._getOption('saveRowChanges');
    }
    set saveRowChanges(value) {
      this._setOption('saveRowChanges', value);
    }
    get undeleteRow() {
      return this._getOption('undeleteRow');
    }
    set undeleteRow(value) {
      this._setOption('undeleteRow', value);
    }
    get validationCancelChanges() {
      return this._getOption('validationCancelChanges');
    }
    set validationCancelChanges(value) {
      this._setOption('validationCancelChanges', value);
    }
    get _optionPath() {
      return 'texts';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridEditingTextsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridEditingTextsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridEditingTextsComponent,
      selectors: [["dxo-data-grid-editing-texts"]],
      inputs: {
        addRow: "addRow",
        cancelAllChanges: "cancelAllChanges",
        cancelRowChanges: "cancelRowChanges",
        confirmDeleteMessage: "confirmDeleteMessage",
        confirmDeleteTitle: "confirmDeleteTitle",
        deleteRow: "deleteRow",
        editRow: "editRow",
        saveAllChanges: "saveAllChanges",
        saveRowChanges: "saveRowChanges",
        undeleteRow: "undeleteRow",
        validationCancelChanges: "validationCancelChanges"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridEditingTextsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridEditingTextsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridEditingTextsModule = /*#__PURE__*/(() => {
  class DxoDataGridEditingTextsModule {
    /** @nocollapse */static ɵfac = function DxoDataGridEditingTextsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridEditingTextsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridEditingTextsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridEditingTextsComponent]
    });
  }
  return DxoDataGridEditingTextsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridEditingComponent = /*#__PURE__*/(() => {
  class DxoDataGridEditingComponent extends NestedOption {
    set _changesContentChildren(value) {
      this.setChildren('changes', value);
    }
    get allowAdding() {
      return this._getOption('allowAdding');
    }
    set allowAdding(value) {
      this._setOption('allowAdding', value);
    }
    get allowDeleting() {
      return this._getOption('allowDeleting');
    }
    set allowDeleting(value) {
      this._setOption('allowDeleting', value);
    }
    get allowUpdating() {
      return this._getOption('allowUpdating');
    }
    set allowUpdating(value) {
      this._setOption('allowUpdating', value);
    }
    get changes() {
      return this._getOption('changes');
    }
    set changes(value) {
      this._setOption('changes', value);
    }
    get confirmDelete() {
      return this._getOption('confirmDelete');
    }
    set confirmDelete(value) {
      this._setOption('confirmDelete', value);
    }
    get editColumnName() {
      return this._getOption('editColumnName');
    }
    set editColumnName(value) {
      this._setOption('editColumnName', value);
    }
    get editRowKey() {
      return this._getOption('editRowKey');
    }
    set editRowKey(value) {
      this._setOption('editRowKey', value);
    }
    get form() {
      return this._getOption('form');
    }
    set form(value) {
      this._setOption('form', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get newRowPosition() {
      return this._getOption('newRowPosition');
    }
    set newRowPosition(value) {
      this._setOption('newRowPosition', value);
    }
    get popup() {
      return this._getOption('popup');
    }
    set popup(value) {
      this._setOption('popup', value);
    }
    get refreshMode() {
      return this._getOption('refreshMode');
    }
    set refreshMode(value) {
      this._setOption('refreshMode', value);
    }
    get selectTextOnEditStart() {
      return this._getOption('selectTextOnEditStart');
    }
    set selectTextOnEditStart(value) {
      this._setOption('selectTextOnEditStart', value);
    }
    get startEditAction() {
      return this._getOption('startEditAction');
    }
    set startEditAction(value) {
      this._setOption('startEditAction', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get useIcons() {
      return this._getOption('useIcons');
    }
    set useIcons(value) {
      this._setOption('useIcons', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    changesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    editColumnNameChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    editRowKeyChange;
    get _optionPath() {
      return 'editing';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'changesChange'
      }, {
        emit: 'editColumnNameChange'
      }, {
        emit: 'editRowKeyChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridEditingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridEditingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridEditingComponent,
      selectors: [["dxo-data-grid-editing"]],
      contentQueries: function DxoDataGridEditingComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_changes, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._changesContentChildren = _t);
        }
      },
      inputs: {
        allowAdding: "allowAdding",
        allowDeleting: "allowDeleting",
        allowUpdating: "allowUpdating",
        changes: "changes",
        confirmDelete: "confirmDelete",
        editColumnName: "editColumnName",
        editRowKey: "editRowKey",
        form: "form",
        mode: "mode",
        newRowPosition: "newRowPosition",
        popup: "popup",
        refreshMode: "refreshMode",
        selectTextOnEditStart: "selectTextOnEditStart",
        startEditAction: "startEditAction",
        texts: "texts",
        useIcons: "useIcons"
      },
      outputs: {
        changesChange: "changesChange",
        editColumnNameChange: "editColumnNameChange",
        editRowKeyChange: "editRowKeyChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridEditingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridEditingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridEditingModule = /*#__PURE__*/(() => {
  class DxoDataGridEditingModule {
    /** @nocollapse */static ɵfac = function DxoDataGridEditingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridEditingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridEditingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridEditingComponent]
    });
  }
  return DxoDataGridEditingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridEmailRuleComponent = /*#__PURE__*/(() => {
  class DxiDataGridEmailRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'email';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridEmailRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridEmailRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridEmailRuleComponent,
      selectors: [["dxi-data-grid-email-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        message: "message",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiDataGridEmailRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridEmailRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridEmailRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridEmailRuleModule = /*#__PURE__*/(() => {
  class DxiDataGridEmailRuleModule {
    /** @nocollapse */static ɵfac = function DxiDataGridEmailRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridEmailRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridEmailRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridEmailRuleComponent]
    });
  }
  return DxiDataGridEmailRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridExportTextsComponent = /*#__PURE__*/(() => {
  class DxoDataGridExportTextsComponent extends NestedOption {
    get exportAll() {
      return this._getOption('exportAll');
    }
    set exportAll(value) {
      this._setOption('exportAll', value);
    }
    get exportSelectedRows() {
      return this._getOption('exportSelectedRows');
    }
    set exportSelectedRows(value) {
      this._setOption('exportSelectedRows', value);
    }
    get exportTo() {
      return this._getOption('exportTo');
    }
    set exportTo(value) {
      this._setOption('exportTo', value);
    }
    get _optionPath() {
      return 'texts';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridExportTextsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridExportTextsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridExportTextsComponent,
      selectors: [["dxo-data-grid-export-texts"]],
      inputs: {
        exportAll: "exportAll",
        exportSelectedRows: "exportSelectedRows",
        exportTo: "exportTo"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridExportTextsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridExportTextsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridExportTextsModule = /*#__PURE__*/(() => {
  class DxoDataGridExportTextsModule {
    /** @nocollapse */static ɵfac = function DxoDataGridExportTextsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridExportTextsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridExportTextsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridExportTextsComponent]
    });
  }
  return DxoDataGridExportTextsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridExportComponent = /*#__PURE__*/(() => {
  class DxoDataGridExportComponent extends NestedOption {
    get allowExportSelectedData() {
      return this._getOption('allowExportSelectedData');
    }
    set allowExportSelectedData(value) {
      this._setOption('allowExportSelectedData', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get formats() {
      return this._getOption('formats');
    }
    set formats(value) {
      this._setOption('formats', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get _optionPath() {
      return 'export';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridExportComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridExportComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridExportComponent,
      selectors: [["dxo-data-grid-export"]],
      inputs: {
        allowExportSelectedData: "allowExportSelectedData",
        enabled: "enabled",
        formats: "formats",
        texts: "texts"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridExportComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridExportComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridExportModule = /*#__PURE__*/(() => {
  class DxoDataGridExportModule {
    /** @nocollapse */static ɵfac = function DxoDataGridExportModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridExportModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridExportModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridExportComponent]
    });
  }
  return DxoDataGridExportModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridFieldComponent = /*#__PURE__*/(() => {
  class DxiDataGridFieldComponent extends CollectionNestedOption {
    get calculateFilterExpression() {
      return this._getOption('calculateFilterExpression');
    }
    set calculateFilterExpression(value) {
      this._setOption('calculateFilterExpression', value);
    }
    get caption() {
      return this._getOption('caption');
    }
    set caption(value) {
      this._setOption('caption', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get dataField() {
      return this._getOption('dataField');
    }
    set dataField(value) {
      this._setOption('dataField', value);
    }
    get dataType() {
      return this._getOption('dataType');
    }
    set dataType(value) {
      this._setOption('dataType', value);
    }
    get editorOptions() {
      return this._getOption('editorOptions');
    }
    set editorOptions(value) {
      this._setOption('editorOptions', value);
    }
    get editorTemplate() {
      return this._getOption('editorTemplate');
    }
    set editorTemplate(value) {
      this._setOption('editorTemplate', value);
    }
    get falseText() {
      return this._getOption('falseText');
    }
    set falseText(value) {
      this._setOption('falseText', value);
    }
    get filterOperations() {
      return this._getOption('filterOperations');
    }
    set filterOperations(value) {
      this._setOption('filterOperations', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get lookup() {
      return this._getOption('lookup');
    }
    set lookup(value) {
      this._setOption('lookup', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get trueText() {
      return this._getOption('trueText');
    }
    set trueText(value) {
      this._setOption('trueText', value);
    }
    get _optionPath() {
      return 'fields';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridFieldComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridFieldComponent,
      selectors: [["dxi-data-grid-field"]],
      inputs: {
        calculateFilterExpression: "calculateFilterExpression",
        caption: "caption",
        customizeText: "customizeText",
        dataField: "dataField",
        dataType: "dataType",
        editorOptions: "editorOptions",
        editorTemplate: "editorTemplate",
        falseText: "falseText",
        filterOperations: "filterOperations",
        format: "format",
        lookup: "lookup",
        name: "name",
        trueText: "trueText"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_fields,
        useExisting: DxiDataGridFieldComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridFieldComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridFieldComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridFieldModule = /*#__PURE__*/(() => {
  class DxiDataGridFieldModule {
    /** @nocollapse */static ɵfac = function DxiDataGridFieldModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridFieldModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridFieldModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridFieldComponent]
    });
  }
  return DxiDataGridFieldModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridFieldLookupComponent = /*#__PURE__*/(() => {
  class DxoDataGridFieldLookupComponent extends NestedOption {
    get allowClearing() {
      return this._getOption('allowClearing');
    }
    set allowClearing(value) {
      this._setOption('allowClearing', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get displayExpr() {
      return this._getOption('displayExpr');
    }
    set displayExpr(value) {
      this._setOption('displayExpr', value);
    }
    get valueExpr() {
      return this._getOption('valueExpr');
    }
    set valueExpr(value) {
      this._setOption('valueExpr', value);
    }
    get _optionPath() {
      return 'lookup';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridFieldLookupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFieldLookupComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridFieldLookupComponent,
      selectors: [["dxo-data-grid-field-lookup"]],
      inputs: {
        allowClearing: "allowClearing",
        dataSource: "dataSource",
        displayExpr: "displayExpr",
        valueExpr: "valueExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridFieldLookupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridFieldLookupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridFieldLookupModule = /*#__PURE__*/(() => {
  class DxoDataGridFieldLookupModule {
    /** @nocollapse */static ɵfac = function DxoDataGridFieldLookupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFieldLookupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridFieldLookupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridFieldLookupComponent]
    });
  }
  return DxoDataGridFieldLookupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridFilterBuilderPopupComponent = /*#__PURE__*/(() => {
  class DxoDataGridFilterBuilderPopupComponent extends NestedOption {
    set _toolbarItemsContentChildren(value) {
      this.setChildren('toolbarItems', value);
    }
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get animation() {
      return this._getOption('animation');
    }
    set animation(value) {
      this._setOption('animation', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get contentTemplate() {
      return this._getOption('contentTemplate');
    }
    set contentTemplate(value) {
      this._setOption('contentTemplate', value);
    }
    get deferRendering() {
      return this._getOption('deferRendering');
    }
    set deferRendering(value) {
      this._setOption('deferRendering', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get dragAndResizeArea() {
      return this._getOption('dragAndResizeArea');
    }
    set dragAndResizeArea(value) {
      this._setOption('dragAndResizeArea', value);
    }
    get dragEnabled() {
      return this._getOption('dragEnabled');
    }
    set dragEnabled(value) {
      this._setOption('dragEnabled', value);
    }
    get dragOutsideBoundary() {
      return this._getOption('dragOutsideBoundary');
    }
    set dragOutsideBoundary(value) {
      this._setOption('dragOutsideBoundary', value);
    }
    get enableBodyScroll() {
      return this._getOption('enableBodyScroll');
    }
    set enableBodyScroll(value) {
      this._setOption('enableBodyScroll', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get fullScreen() {
      return this._getOption('fullScreen');
    }
    set fullScreen(value) {
      this._setOption('fullScreen', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hideOnOutsideClick() {
      return this._getOption('hideOnOutsideClick');
    }
    set hideOnOutsideClick(value) {
      this._setOption('hideOnOutsideClick', value);
    }
    get hideOnParentScroll() {
      return this._getOption('hideOnParentScroll');
    }
    set hideOnParentScroll(value) {
      this._setOption('hideOnParentScroll', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get maxHeight() {
      return this._getOption('maxHeight');
    }
    set maxHeight(value) {
      this._setOption('maxHeight', value);
    }
    get maxWidth() {
      return this._getOption('maxWidth');
    }
    set maxWidth(value) {
      this._setOption('maxWidth', value);
    }
    get minHeight() {
      return this._getOption('minHeight');
    }
    set minHeight(value) {
      this._setOption('minHeight', value);
    }
    get minWidth() {
      return this._getOption('minWidth');
    }
    set minWidth(value) {
      this._setOption('minWidth', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onHidden() {
      return this._getOption('onHidden');
    }
    set onHidden(value) {
      this._setOption('onHidden', value);
    }
    get onHiding() {
      return this._getOption('onHiding');
    }
    set onHiding(value) {
      this._setOption('onHiding', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onResize() {
      return this._getOption('onResize');
    }
    set onResize(value) {
      this._setOption('onResize', value);
    }
    get onResizeEnd() {
      return this._getOption('onResizeEnd');
    }
    set onResizeEnd(value) {
      this._setOption('onResizeEnd', value);
    }
    get onResizeStart() {
      return this._getOption('onResizeStart');
    }
    set onResizeStart(value) {
      this._setOption('onResizeStart', value);
    }
    get onShowing() {
      return this._getOption('onShowing');
    }
    set onShowing(value) {
      this._setOption('onShowing', value);
    }
    get onShown() {
      return this._getOption('onShown');
    }
    set onShown(value) {
      this._setOption('onShown', value);
    }
    get onTitleRendered() {
      return this._getOption('onTitleRendered');
    }
    set onTitleRendered(value) {
      this._setOption('onTitleRendered', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get resizeEnabled() {
      return this._getOption('resizeEnabled');
    }
    set resizeEnabled(value) {
      this._setOption('resizeEnabled', value);
    }
    get restorePosition() {
      return this._getOption('restorePosition');
    }
    set restorePosition(value) {
      this._setOption('restorePosition', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get shading() {
      return this._getOption('shading');
    }
    set shading(value) {
      this._setOption('shading', value);
    }
    get shadingColor() {
      return this._getOption('shadingColor');
    }
    set shadingColor(value) {
      this._setOption('shadingColor', value);
    }
    get showCloseButton() {
      return this._getOption('showCloseButton');
    }
    set showCloseButton(value) {
      this._setOption('showCloseButton', value);
    }
    get showTitle() {
      return this._getOption('showTitle');
    }
    set showTitle(value) {
      this._setOption('showTitle', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get titleTemplate() {
      return this._getOption('titleTemplate');
    }
    set titleTemplate(value) {
      this._setOption('titleTemplate', value);
    }
    get toolbarItems() {
      return this._getOption('toolbarItems');
    }
    set toolbarItems(value) {
      this._setOption('toolbarItems', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wrapperAttr() {
      return this._getOption('wrapperAttr');
    }
    set wrapperAttr(value) {
      this._setOption('wrapperAttr', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    positionChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    get _optionPath() {
      return 'filterBuilderPopup';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'heightChange'
      }, {
        emit: 'positionChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'widthChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridFilterBuilderPopupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFilterBuilderPopupComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridFilterBuilderPopupComponent,
      selectors: [["dxo-data-grid-filter-builder-popup"]],
      contentQueries: function DxoDataGridFilterBuilderPopupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_toolbarItems, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._toolbarItemsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        animation: "animation",
        container: "container",
        contentTemplate: "contentTemplate",
        deferRendering: "deferRendering",
        disabled: "disabled",
        dragAndResizeArea: "dragAndResizeArea",
        dragEnabled: "dragEnabled",
        dragOutsideBoundary: "dragOutsideBoundary",
        enableBodyScroll: "enableBodyScroll",
        focusStateEnabled: "focusStateEnabled",
        fullScreen: "fullScreen",
        height: "height",
        hideOnOutsideClick: "hideOnOutsideClick",
        hideOnParentScroll: "hideOnParentScroll",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        maxHeight: "maxHeight",
        maxWidth: "maxWidth",
        minHeight: "minHeight",
        minWidth: "minWidth",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onHidden: "onHidden",
        onHiding: "onHiding",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onResize: "onResize",
        onResizeEnd: "onResizeEnd",
        onResizeStart: "onResizeStart",
        onShowing: "onShowing",
        onShown: "onShown",
        onTitleRendered: "onTitleRendered",
        position: "position",
        resizeEnabled: "resizeEnabled",
        restorePosition: "restorePosition",
        rtlEnabled: "rtlEnabled",
        shading: "shading",
        shadingColor: "shadingColor",
        showCloseButton: "showCloseButton",
        showTitle: "showTitle",
        tabIndex: "tabIndex",
        title: "title",
        titleTemplate: "titleTemplate",
        toolbarItems: "toolbarItems",
        visible: "visible",
        width: "width",
        wrapperAttr: "wrapperAttr"
      },
      outputs: {
        heightChange: "heightChange",
        positionChange: "positionChange",
        visibleChange: "visibleChange",
        widthChange: "widthChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridFilterBuilderPopupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridFilterBuilderPopupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridFilterBuilderPopupModule = /*#__PURE__*/(() => {
  class DxoDataGridFilterBuilderPopupModule {
    /** @nocollapse */static ɵfac = function DxoDataGridFilterBuilderPopupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFilterBuilderPopupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridFilterBuilderPopupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridFilterBuilderPopupComponent]
    });
  }
  return DxoDataGridFilterBuilderPopupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridFilterBuilderComponent = /*#__PURE__*/(() => {
  class DxoDataGridFilterBuilderComponent extends NestedOption {
    set _customOperationsContentChildren(value) {
      this.setChildren('customOperations', value);
    }
    set _fieldsContentChildren(value) {
      this.setChildren('fields', value);
    }
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get allowHierarchicalFields() {
      return this._getOption('allowHierarchicalFields');
    }
    set allowHierarchicalFields(value) {
      this._setOption('allowHierarchicalFields', value);
    }
    get customOperations() {
      return this._getOption('customOperations');
    }
    set customOperations(value) {
      this._setOption('customOperations', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get fields() {
      return this._getOption('fields');
    }
    set fields(value) {
      this._setOption('fields', value);
    }
    get filterOperationDescriptions() {
      return this._getOption('filterOperationDescriptions');
    }
    set filterOperationDescriptions(value) {
      this._setOption('filterOperationDescriptions', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get groupOperationDescriptions() {
      return this._getOption('groupOperationDescriptions');
    }
    set groupOperationDescriptions(value) {
      this._setOption('groupOperationDescriptions', value);
    }
    get groupOperations() {
      return this._getOption('groupOperations');
    }
    set groupOperations(value) {
      this._setOption('groupOperations', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get maxGroupLevel() {
      return this._getOption('maxGroupLevel');
    }
    set maxGroupLevel(value) {
      this._setOption('maxGroupLevel', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onEditorPrepared() {
      return this._getOption('onEditorPrepared');
    }
    set onEditorPrepared(value) {
      this._setOption('onEditorPrepared', value);
    }
    get onEditorPreparing() {
      return this._getOption('onEditorPreparing');
    }
    set onEditorPreparing(value) {
      this._setOption('onEditorPreparing', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onValueChanged() {
      return this._getOption('onValueChanged');
    }
    set onValueChanged(value) {
      this._setOption('onValueChanged', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    valueChange;
    get _optionPath() {
      return 'filterBuilder';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'valueChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridFilterBuilderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFilterBuilderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridFilterBuilderComponent,
      selectors: [["dxo-data-grid-filter-builder"]],
      contentQueries: function DxoDataGridFilterBuilderComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_customOperations, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_fields, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._customOperationsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._fieldsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        allowHierarchicalFields: "allowHierarchicalFields",
        customOperations: "customOperations",
        disabled: "disabled",
        elementAttr: "elementAttr",
        fields: "fields",
        filterOperationDescriptions: "filterOperationDescriptions",
        focusStateEnabled: "focusStateEnabled",
        groupOperationDescriptions: "groupOperationDescriptions",
        groupOperations: "groupOperations",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        maxGroupLevel: "maxGroupLevel",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onEditorPrepared: "onEditorPrepared",
        onEditorPreparing: "onEditorPreparing",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onValueChanged: "onValueChanged",
        rtlEnabled: "rtlEnabled",
        tabIndex: "tabIndex",
        value: "value",
        visible: "visible",
        width: "width"
      },
      outputs: {
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridFilterBuilderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridFilterBuilderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridFilterBuilderModule = /*#__PURE__*/(() => {
  class DxoDataGridFilterBuilderModule {
    /** @nocollapse */static ɵfac = function DxoDataGridFilterBuilderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFilterBuilderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridFilterBuilderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridFilterBuilderComponent]
    });
  }
  return DxoDataGridFilterBuilderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridFilterOperationDescriptionsComponent = /*#__PURE__*/(() => {
  class DxoDataGridFilterOperationDescriptionsComponent extends NestedOption {
    get between() {
      return this._getOption('between');
    }
    set between(value) {
      this._setOption('between', value);
    }
    get contains() {
      return this._getOption('contains');
    }
    set contains(value) {
      this._setOption('contains', value);
    }
    get endsWith() {
      return this._getOption('endsWith');
    }
    set endsWith(value) {
      this._setOption('endsWith', value);
    }
    get equal() {
      return this._getOption('equal');
    }
    set equal(value) {
      this._setOption('equal', value);
    }
    get greaterThan() {
      return this._getOption('greaterThan');
    }
    set greaterThan(value) {
      this._setOption('greaterThan', value);
    }
    get greaterThanOrEqual() {
      return this._getOption('greaterThanOrEqual');
    }
    set greaterThanOrEqual(value) {
      this._setOption('greaterThanOrEqual', value);
    }
    get isBlank() {
      return this._getOption('isBlank');
    }
    set isBlank(value) {
      this._setOption('isBlank', value);
    }
    get isNotBlank() {
      return this._getOption('isNotBlank');
    }
    set isNotBlank(value) {
      this._setOption('isNotBlank', value);
    }
    get lessThan() {
      return this._getOption('lessThan');
    }
    set lessThan(value) {
      this._setOption('lessThan', value);
    }
    get lessThanOrEqual() {
      return this._getOption('lessThanOrEqual');
    }
    set lessThanOrEqual(value) {
      this._setOption('lessThanOrEqual', value);
    }
    get notContains() {
      return this._getOption('notContains');
    }
    set notContains(value) {
      this._setOption('notContains', value);
    }
    get notEqual() {
      return this._getOption('notEqual');
    }
    set notEqual(value) {
      this._setOption('notEqual', value);
    }
    get startsWith() {
      return this._getOption('startsWith');
    }
    set startsWith(value) {
      this._setOption('startsWith', value);
    }
    get _optionPath() {
      return 'filterOperationDescriptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridFilterOperationDescriptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFilterOperationDescriptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridFilterOperationDescriptionsComponent,
      selectors: [["dxo-data-grid-filter-operation-descriptions"]],
      inputs: {
        between: "between",
        contains: "contains",
        endsWith: "endsWith",
        equal: "equal",
        greaterThan: "greaterThan",
        greaterThanOrEqual: "greaterThanOrEqual",
        isBlank: "isBlank",
        isNotBlank: "isNotBlank",
        lessThan: "lessThan",
        lessThanOrEqual: "lessThanOrEqual",
        notContains: "notContains",
        notEqual: "notEqual",
        startsWith: "startsWith"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridFilterOperationDescriptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridFilterOperationDescriptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridFilterOperationDescriptionsModule = /*#__PURE__*/(() => {
  class DxoDataGridFilterOperationDescriptionsModule {
    /** @nocollapse */static ɵfac = function DxoDataGridFilterOperationDescriptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFilterOperationDescriptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridFilterOperationDescriptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridFilterOperationDescriptionsComponent]
    });
  }
  return DxoDataGridFilterOperationDescriptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridFilterPanelTextsComponent = /*#__PURE__*/(() => {
  class DxoDataGridFilterPanelTextsComponent extends NestedOption {
    get clearFilter() {
      return this._getOption('clearFilter');
    }
    set clearFilter(value) {
      this._setOption('clearFilter', value);
    }
    get createFilter() {
      return this._getOption('createFilter');
    }
    set createFilter(value) {
      this._setOption('createFilter', value);
    }
    get filterEnabledHint() {
      return this._getOption('filterEnabledHint');
    }
    set filterEnabledHint(value) {
      this._setOption('filterEnabledHint', value);
    }
    get _optionPath() {
      return 'texts';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridFilterPanelTextsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFilterPanelTextsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridFilterPanelTextsComponent,
      selectors: [["dxo-data-grid-filter-panel-texts"]],
      inputs: {
        clearFilter: "clearFilter",
        createFilter: "createFilter",
        filterEnabledHint: "filterEnabledHint"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridFilterPanelTextsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridFilterPanelTextsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridFilterPanelTextsModule = /*#__PURE__*/(() => {
  class DxoDataGridFilterPanelTextsModule {
    /** @nocollapse */static ɵfac = function DxoDataGridFilterPanelTextsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFilterPanelTextsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridFilterPanelTextsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridFilterPanelTextsComponent]
    });
  }
  return DxoDataGridFilterPanelTextsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridFilterPanelComponent = /*#__PURE__*/(() => {
  class DxoDataGridFilterPanelComponent extends NestedOption {
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get filterEnabled() {
      return this._getOption('filterEnabled');
    }
    set filterEnabled(value) {
      this._setOption('filterEnabled', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    filterEnabledChange;
    get _optionPath() {
      return 'filterPanel';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'filterEnabledChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridFilterPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFilterPanelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridFilterPanelComponent,
      selectors: [["dxo-data-grid-filter-panel"]],
      inputs: {
        customizeText: "customizeText",
        filterEnabled: "filterEnabled",
        texts: "texts",
        visible: "visible"
      },
      outputs: {
        filterEnabledChange: "filterEnabledChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridFilterPanelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridFilterPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridFilterPanelModule = /*#__PURE__*/(() => {
  class DxoDataGridFilterPanelModule {
    /** @nocollapse */static ɵfac = function DxoDataGridFilterPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFilterPanelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridFilterPanelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridFilterPanelComponent]
    });
  }
  return DxoDataGridFilterPanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridFilterRowComponent = /*#__PURE__*/(() => {
  class DxoDataGridFilterRowComponent extends NestedOption {
    get applyFilter() {
      return this._getOption('applyFilter');
    }
    set applyFilter(value) {
      this._setOption('applyFilter', value);
    }
    get applyFilterText() {
      return this._getOption('applyFilterText');
    }
    set applyFilterText(value) {
      this._setOption('applyFilterText', value);
    }
    get betweenEndText() {
      return this._getOption('betweenEndText');
    }
    set betweenEndText(value) {
      this._setOption('betweenEndText', value);
    }
    get betweenStartText() {
      return this._getOption('betweenStartText');
    }
    set betweenStartText(value) {
      this._setOption('betweenStartText', value);
    }
    get operationDescriptions() {
      return this._getOption('operationDescriptions');
    }
    set operationDescriptions(value) {
      this._setOption('operationDescriptions', value);
    }
    get resetOperationText() {
      return this._getOption('resetOperationText');
    }
    set resetOperationText(value) {
      this._setOption('resetOperationText', value);
    }
    get showAllText() {
      return this._getOption('showAllText');
    }
    set showAllText(value) {
      this._setOption('showAllText', value);
    }
    get showOperationChooser() {
      return this._getOption('showOperationChooser');
    }
    set showOperationChooser(value) {
      this._setOption('showOperationChooser', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'filterRow';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridFilterRowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFilterRowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridFilterRowComponent,
      selectors: [["dxo-data-grid-filter-row"]],
      inputs: {
        applyFilter: "applyFilter",
        applyFilterText: "applyFilterText",
        betweenEndText: "betweenEndText",
        betweenStartText: "betweenStartText",
        operationDescriptions: "operationDescriptions",
        resetOperationText: "resetOperationText",
        showAllText: "showAllText",
        showOperationChooser: "showOperationChooser",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridFilterRowComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridFilterRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridFilterRowModule = /*#__PURE__*/(() => {
  class DxoDataGridFilterRowModule {
    /** @nocollapse */static ɵfac = function DxoDataGridFilterRowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFilterRowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridFilterRowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridFilterRowComponent]
    });
  }
  return DxoDataGridFilterRowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridFormItemComponent = /*#__PURE__*/(() => {
  class DxoDataGridFormItemComponent extends NestedOption {
    renderer;
    document;
    element;
    set _validationRulesContentChildren(value) {
      this.setChildren('validationRules', value);
    }
    get colSpan() {
      return this._getOption('colSpan');
    }
    set colSpan(value) {
      this._setOption('colSpan', value);
    }
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get dataField() {
      return this._getOption('dataField');
    }
    set dataField(value) {
      this._setOption('dataField', value);
    }
    get editorOptions() {
      return this._getOption('editorOptions');
    }
    set editorOptions(value) {
      this._setOption('editorOptions', value);
    }
    get editorType() {
      return this._getOption('editorType');
    }
    set editorType(value) {
      this._setOption('editorType', value);
    }
    get helpText() {
      return this._getOption('helpText');
    }
    set helpText(value) {
      this._setOption('helpText', value);
    }
    get isRequired() {
      return this._getOption('isRequired');
    }
    set isRequired(value) {
      this._setOption('isRequired', value);
    }
    get itemType() {
      return this._getOption('itemType');
    }
    set itemType(value) {
      this._setOption('itemType', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get validationRules() {
      return this._getOption('validationRules');
    }
    set validationRules(value) {
      this._setOption('validationRules', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get visibleIndex() {
      return this._getOption('visibleIndex');
    }
    set visibleIndex(value) {
      this._setOption('visibleIndex', value);
    }
    get _optionPath() {
      return 'formItem';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridFormItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFormItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridFormItemComponent,
      selectors: [["dxo-data-grid-form-item"]],
      contentQueries: function DxoDataGridFormItemComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_validationRules, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._validationRulesContentChildren = _t);
        }
      },
      inputs: {
        colSpan: "colSpan",
        cssClass: "cssClass",
        dataField: "dataField",
        editorOptions: "editorOptions",
        editorType: "editorType",
        helpText: "helpText",
        isRequired: "isRequired",
        itemType: "itemType",
        label: "label",
        name: "name",
        template: "template",
        validationRules: "validationRules",
        visible: "visible",
        visibleIndex: "visibleIndex"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoDataGridFormItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoDataGridFormItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridFormItemModule = /*#__PURE__*/(() => {
  class DxoDataGridFormItemModule {
    /** @nocollapse */static ɵfac = function DxoDataGridFormItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFormItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridFormItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridFormItemComponent]
    });
  }
  return DxoDataGridFormItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridFormComponent = /*#__PURE__*/(() => {
  class DxoDataGridFormComponent extends NestedOption {
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get activeStateEnabled() {
      return this._getOption('activeStateEnabled');
    }
    set activeStateEnabled(value) {
      this._setOption('activeStateEnabled', value);
    }
    get alignItemLabels() {
      return this._getOption('alignItemLabels');
    }
    set alignItemLabels(value) {
      this._setOption('alignItemLabels', value);
    }
    get alignItemLabelsInAllGroups() {
      return this._getOption('alignItemLabelsInAllGroups');
    }
    set alignItemLabelsInAllGroups(value) {
      this._setOption('alignItemLabelsInAllGroups', value);
    }
    get colCount() {
      return this._getOption('colCount');
    }
    set colCount(value) {
      this._setOption('colCount', value);
    }
    get colCountByScreen() {
      return this._getOption('colCountByScreen');
    }
    set colCountByScreen(value) {
      this._setOption('colCountByScreen', value);
    }
    get customizeItem() {
      return this._getOption('customizeItem');
    }
    set customizeItem(value) {
      this._setOption('customizeItem', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get formData() {
      return this._getOption('formData');
    }
    set formData(value) {
      this._setOption('formData', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get isDirty() {
      return this._getOption('isDirty');
    }
    set isDirty(value) {
      this._setOption('isDirty', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get labelLocation() {
      return this._getOption('labelLocation');
    }
    set labelLocation(value) {
      this._setOption('labelLocation', value);
    }
    get labelMode() {
      return this._getOption('labelMode');
    }
    set labelMode(value) {
      this._setOption('labelMode', value);
    }
    get minColWidth() {
      return this._getOption('minColWidth');
    }
    set minColWidth(value) {
      this._setOption('minColWidth', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onEditorEnterKey() {
      return this._getOption('onEditorEnterKey');
    }
    set onEditorEnterKey(value) {
      this._setOption('onEditorEnterKey', value);
    }
    get onFieldDataChanged() {
      return this._getOption('onFieldDataChanged');
    }
    set onFieldDataChanged(value) {
      this._setOption('onFieldDataChanged', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get optionalMark() {
      return this._getOption('optionalMark');
    }
    set optionalMark(value) {
      this._setOption('optionalMark', value);
    }
    get readOnly() {
      return this._getOption('readOnly');
    }
    set readOnly(value) {
      this._setOption('readOnly', value);
    }
    get requiredMark() {
      return this._getOption('requiredMark');
    }
    set requiredMark(value) {
      this._setOption('requiredMark', value);
    }
    get requiredMessage() {
      return this._getOption('requiredMessage');
    }
    set requiredMessage(value) {
      this._setOption('requiredMessage', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get screenByWidth() {
      return this._getOption('screenByWidth');
    }
    set screenByWidth(value) {
      this._setOption('screenByWidth', value);
    }
    get scrollingEnabled() {
      return this._getOption('scrollingEnabled');
    }
    set scrollingEnabled(value) {
      this._setOption('scrollingEnabled', value);
    }
    get showColonAfterLabel() {
      return this._getOption('showColonAfterLabel');
    }
    set showColonAfterLabel(value) {
      this._setOption('showColonAfterLabel', value);
    }
    get showOptionalMark() {
      return this._getOption('showOptionalMark');
    }
    set showOptionalMark(value) {
      this._setOption('showOptionalMark', value);
    }
    get showRequiredMark() {
      return this._getOption('showRequiredMark');
    }
    set showRequiredMark(value) {
      this._setOption('showRequiredMark', value);
    }
    get showValidationSummary() {
      return this._getOption('showValidationSummary');
    }
    set showValidationSummary(value) {
      this._setOption('showValidationSummary', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get validationGroup() {
      return this._getOption('validationGroup');
    }
    set validationGroup(value) {
      this._setOption('validationGroup', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    formDataChange;
    get _optionPath() {
      return 'form';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'formDataChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFormComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridFormComponent,
      selectors: [["dxo-data-grid-form"]],
      inputs: {
        accessKey: "accessKey",
        activeStateEnabled: "activeStateEnabled",
        alignItemLabels: "alignItemLabels",
        alignItemLabelsInAllGroups: "alignItemLabelsInAllGroups",
        colCount: "colCount",
        colCountByScreen: "colCountByScreen",
        customizeItem: "customizeItem",
        disabled: "disabled",
        elementAttr: "elementAttr",
        focusStateEnabled: "focusStateEnabled",
        formData: "formData",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        isDirty: "isDirty",
        items: "items",
        labelLocation: "labelLocation",
        labelMode: "labelMode",
        minColWidth: "minColWidth",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onEditorEnterKey: "onEditorEnterKey",
        onFieldDataChanged: "onFieldDataChanged",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        optionalMark: "optionalMark",
        readOnly: "readOnly",
        requiredMark: "requiredMark",
        requiredMessage: "requiredMessage",
        rtlEnabled: "rtlEnabled",
        screenByWidth: "screenByWidth",
        scrollingEnabled: "scrollingEnabled",
        showColonAfterLabel: "showColonAfterLabel",
        showOptionalMark: "showOptionalMark",
        showRequiredMark: "showRequiredMark",
        showValidationSummary: "showValidationSummary",
        tabIndex: "tabIndex",
        validationGroup: "validationGroup",
        visible: "visible",
        width: "width"
      },
      outputs: {
        formDataChange: "formDataChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridFormComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridFormModule = /*#__PURE__*/(() => {
  class DxoDataGridFormModule {
    /** @nocollapse */static ɵfac = function DxoDataGridFormModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFormModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridFormModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridFormComponent]
    });
  }
  return DxoDataGridFormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridFormatComponent = /*#__PURE__*/(() => {
  class DxoDataGridFormatComponent extends NestedOption {
    get currency() {
      return this._getOption('currency');
    }
    set currency(value) {
      this._setOption('currency', value);
    }
    get formatter() {
      return this._getOption('formatter');
    }
    set formatter(value) {
      this._setOption('formatter', value);
    }
    get parser() {
      return this._getOption('parser');
    }
    set parser(value) {
      this._setOption('parser', value);
    }
    get precision() {
      return this._getOption('precision');
    }
    set precision(value) {
      this._setOption('precision', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useCurrencyAccountingStyle() {
      return this._getOption('useCurrencyAccountingStyle');
    }
    set useCurrencyAccountingStyle(value) {
      this._setOption('useCurrencyAccountingStyle', value);
    }
    get _optionPath() {
      return 'format';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridFormatComponent,
      selectors: [["dxo-data-grid-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridFormatComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridFormatModule = /*#__PURE__*/(() => {
  class DxoDataGridFormatModule {
    /** @nocollapse */static ɵfac = function DxoDataGridFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridFormatComponent]
    });
  }
  return DxoDataGridFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridFromComponent = /*#__PURE__*/(() => {
  class DxoDataGridFromComponent extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get scale() {
      return this._getOption('scale');
    }
    set scale(value) {
      this._setOption('scale', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'from';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridFromComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFromComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridFromComponent,
      selectors: [["dxo-data-grid-from"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridFromComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridFromComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridFromModule = /*#__PURE__*/(() => {
  class DxoDataGridFromModule {
    /** @nocollapse */static ɵfac = function DxoDataGridFromModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridFromModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridFromModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridFromComponent]
    });
  }
  return DxoDataGridFromModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridGroupItemComponent = /*#__PURE__*/(() => {
  class DxiDataGridGroupItemComponent extends CollectionNestedOption {
    get alignByColumn() {
      return this._getOption('alignByColumn');
    }
    set alignByColumn(value) {
      this._setOption('alignByColumn', value);
    }
    get column() {
      return this._getOption('column');
    }
    set column(value) {
      this._setOption('column', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get displayFormat() {
      return this._getOption('displayFormat');
    }
    set displayFormat(value) {
      this._setOption('displayFormat', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get showInColumn() {
      return this._getOption('showInColumn');
    }
    set showInColumn(value) {
      this._setOption('showInColumn', value);
    }
    get showInGroupFooter() {
      return this._getOption('showInGroupFooter');
    }
    set showInGroupFooter(value) {
      this._setOption('showInGroupFooter', value);
    }
    get skipEmptyValues() {
      return this._getOption('skipEmptyValues');
    }
    set skipEmptyValues(value) {
      this._setOption('skipEmptyValues', value);
    }
    get summaryType() {
      return this._getOption('summaryType');
    }
    set summaryType(value) {
      this._setOption('summaryType', value);
    }
    get valueFormat() {
      return this._getOption('valueFormat');
    }
    set valueFormat(value) {
      this._setOption('valueFormat', value);
    }
    get _optionPath() {
      return 'groupItems';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridGroupItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridGroupItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridGroupItemComponent,
      selectors: [["dxi-data-grid-group-item"]],
      inputs: {
        alignByColumn: "alignByColumn",
        column: "column",
        customizeText: "customizeText",
        displayFormat: "displayFormat",
        name: "name",
        showInColumn: "showInColumn",
        showInGroupFooter: "showInGroupFooter",
        skipEmptyValues: "skipEmptyValues",
        summaryType: "summaryType",
        valueFormat: "valueFormat"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_groupItems,
        useExisting: DxiDataGridGroupItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridGroupItemComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridGroupItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridGroupItemModule = /*#__PURE__*/(() => {
  class DxiDataGridGroupItemModule {
    /** @nocollapse */static ɵfac = function DxiDataGridGroupItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridGroupItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridGroupItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridGroupItemComponent]
    });
  }
  return DxiDataGridGroupItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridGroupOperationDescriptionsComponent = /*#__PURE__*/(() => {
  class DxoDataGridGroupOperationDescriptionsComponent extends NestedOption {
    get and() {
      return this._getOption('and');
    }
    set and(value) {
      this._setOption('and', value);
    }
    get notAnd() {
      return this._getOption('notAnd');
    }
    set notAnd(value) {
      this._setOption('notAnd', value);
    }
    get notOr() {
      return this._getOption('notOr');
    }
    set notOr(value) {
      this._setOption('notOr', value);
    }
    get or() {
      return this._getOption('or');
    }
    set or(value) {
      this._setOption('or', value);
    }
    get _optionPath() {
      return 'groupOperationDescriptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridGroupOperationDescriptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridGroupOperationDescriptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridGroupOperationDescriptionsComponent,
      selectors: [["dxo-data-grid-group-operation-descriptions"]],
      inputs: {
        and: "and",
        notAnd: "notAnd",
        notOr: "notOr",
        or: "or"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridGroupOperationDescriptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridGroupOperationDescriptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridGroupOperationDescriptionsModule = /*#__PURE__*/(() => {
  class DxoDataGridGroupOperationDescriptionsModule {
    /** @nocollapse */static ɵfac = function DxoDataGridGroupOperationDescriptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridGroupOperationDescriptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridGroupOperationDescriptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridGroupOperationDescriptionsComponent]
    });
  }
  return DxoDataGridGroupOperationDescriptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridGroupPanelComponent = /*#__PURE__*/(() => {
  class DxoDataGridGroupPanelComponent extends NestedOption {
    get allowColumnDragging() {
      return this._getOption('allowColumnDragging');
    }
    set allowColumnDragging(value) {
      this._setOption('allowColumnDragging', value);
    }
    get emptyPanelText() {
      return this._getOption('emptyPanelText');
    }
    set emptyPanelText(value) {
      this._setOption('emptyPanelText', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    get _optionPath() {
      return 'groupPanel';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'visibleChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridGroupPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridGroupPanelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridGroupPanelComponent,
      selectors: [["dxo-data-grid-group-panel"]],
      inputs: {
        allowColumnDragging: "allowColumnDragging",
        emptyPanelText: "emptyPanelText",
        visible: "visible"
      },
      outputs: {
        visibleChange: "visibleChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridGroupPanelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridGroupPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridGroupPanelModule = /*#__PURE__*/(() => {
  class DxoDataGridGroupPanelModule {
    /** @nocollapse */static ɵfac = function DxoDataGridGroupPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridGroupPanelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridGroupPanelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridGroupPanelComponent]
    });
  }
  return DxoDataGridGroupPanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridGroupingTextsComponent = /*#__PURE__*/(() => {
  class DxoDataGridGroupingTextsComponent extends NestedOption {
    get groupByThisColumn() {
      return this._getOption('groupByThisColumn');
    }
    set groupByThisColumn(value) {
      this._setOption('groupByThisColumn', value);
    }
    get groupContinuedMessage() {
      return this._getOption('groupContinuedMessage');
    }
    set groupContinuedMessage(value) {
      this._setOption('groupContinuedMessage', value);
    }
    get groupContinuesMessage() {
      return this._getOption('groupContinuesMessage');
    }
    set groupContinuesMessage(value) {
      this._setOption('groupContinuesMessage', value);
    }
    get ungroup() {
      return this._getOption('ungroup');
    }
    set ungroup(value) {
      this._setOption('ungroup', value);
    }
    get ungroupAll() {
      return this._getOption('ungroupAll');
    }
    set ungroupAll(value) {
      this._setOption('ungroupAll', value);
    }
    get _optionPath() {
      return 'texts';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridGroupingTextsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridGroupingTextsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridGroupingTextsComponent,
      selectors: [["dxo-data-grid-grouping-texts"]],
      inputs: {
        groupByThisColumn: "groupByThisColumn",
        groupContinuedMessage: "groupContinuedMessage",
        groupContinuesMessage: "groupContinuesMessage",
        ungroup: "ungroup",
        ungroupAll: "ungroupAll"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridGroupingTextsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridGroupingTextsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridGroupingTextsModule = /*#__PURE__*/(() => {
  class DxoDataGridGroupingTextsModule {
    /** @nocollapse */static ɵfac = function DxoDataGridGroupingTextsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridGroupingTextsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridGroupingTextsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridGroupingTextsComponent]
    });
  }
  return DxoDataGridGroupingTextsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridGroupingComponent = /*#__PURE__*/(() => {
  class DxoDataGridGroupingComponent extends NestedOption {
    get allowCollapsing() {
      return this._getOption('allowCollapsing');
    }
    set allowCollapsing(value) {
      this._setOption('allowCollapsing', value);
    }
    get autoExpandAll() {
      return this._getOption('autoExpandAll');
    }
    set autoExpandAll(value) {
      this._setOption('autoExpandAll', value);
    }
    get contextMenuEnabled() {
      return this._getOption('contextMenuEnabled');
    }
    set contextMenuEnabled(value) {
      this._setOption('contextMenuEnabled', value);
    }
    get expandMode() {
      return this._getOption('expandMode');
    }
    set expandMode(value) {
      this._setOption('expandMode', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get _optionPath() {
      return 'grouping';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridGroupingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridGroupingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridGroupingComponent,
      selectors: [["dxo-data-grid-grouping"]],
      inputs: {
        allowCollapsing: "allowCollapsing",
        autoExpandAll: "autoExpandAll",
        contextMenuEnabled: "contextMenuEnabled",
        expandMode: "expandMode",
        texts: "texts"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridGroupingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridGroupingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridGroupingModule = /*#__PURE__*/(() => {
  class DxoDataGridGroupingModule {
    /** @nocollapse */static ɵfac = function DxoDataGridGroupingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridGroupingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridGroupingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridGroupingComponent]
    });
  }
  return DxoDataGridGroupingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridHeaderFilterComponent = /*#__PURE__*/(() => {
  class DxoDataGridHeaderFilterComponent extends NestedOption {
    get allowSearch() {
      return this._getOption('allowSearch');
    }
    set allowSearch(value) {
      this._setOption('allowSearch', value);
    }
    get allowSelectAll() {
      return this._getOption('allowSelectAll');
    }
    set allowSelectAll(value) {
      this._setOption('allowSelectAll', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get groupInterval() {
      return this._getOption('groupInterval');
    }
    set groupInterval(value) {
      this._setOption('groupInterval', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get search() {
      return this._getOption('search');
    }
    set search(value) {
      this._setOption('search', value);
    }
    get searchMode() {
      return this._getOption('searchMode');
    }
    set searchMode(value) {
      this._setOption('searchMode', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get searchTimeout() {
      return this._getOption('searchTimeout');
    }
    set searchTimeout(value) {
      this._setOption('searchTimeout', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'headerFilter';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridHeaderFilterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridHeaderFilterComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridHeaderFilterComponent,
      selectors: [["dxo-data-grid-header-filter"]],
      inputs: {
        allowSearch: "allowSearch",
        allowSelectAll: "allowSelectAll",
        dataSource: "dataSource",
        groupInterval: "groupInterval",
        height: "height",
        search: "search",
        searchMode: "searchMode",
        width: "width",
        searchTimeout: "searchTimeout",
        texts: "texts",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridHeaderFilterComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridHeaderFilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridHeaderFilterModule = /*#__PURE__*/(() => {
  class DxoDataGridHeaderFilterModule {
    /** @nocollapse */static ɵfac = function DxoDataGridHeaderFilterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridHeaderFilterModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridHeaderFilterModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridHeaderFilterComponent]
    });
  }
  return DxoDataGridHeaderFilterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridHideComponent = /*#__PURE__*/(() => {
  class DxoDataGridHideComponent extends NestedOption {
    get complete() {
      return this._getOption('complete');
    }
    set complete(value) {
      this._setOption('complete', value);
    }
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get staggerDelay() {
      return this._getOption('staggerDelay');
    }
    set staggerDelay(value) {
      this._setOption('staggerDelay', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'hide';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridHideComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridHideComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridHideComponent,
      selectors: [["dxo-data-grid-hide"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridHideComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridHideComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridHideModule = /*#__PURE__*/(() => {
  class DxoDataGridHideModule {
    /** @nocollapse */static ɵfac = function DxoDataGridHideModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridHideModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridHideModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridHideComponent]
    });
  }
  return DxoDataGridHideModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridIconsComponent = /*#__PURE__*/(() => {
  class DxoDataGridIconsComponent extends NestedOption {
    get fix() {
      return this._getOption('fix');
    }
    set fix(value) {
      this._setOption('fix', value);
    }
    get leftPosition() {
      return this._getOption('leftPosition');
    }
    set leftPosition(value) {
      this._setOption('leftPosition', value);
    }
    get rightPosition() {
      return this._getOption('rightPosition');
    }
    set rightPosition(value) {
      this._setOption('rightPosition', value);
    }
    get stickyPosition() {
      return this._getOption('stickyPosition');
    }
    set stickyPosition(value) {
      this._setOption('stickyPosition', value);
    }
    get unfix() {
      return this._getOption('unfix');
    }
    set unfix(value) {
      this._setOption('unfix', value);
    }
    get _optionPath() {
      return 'icons';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridIconsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridIconsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridIconsComponent,
      selectors: [["dxo-data-grid-icons"]],
      inputs: {
        fix: "fix",
        leftPosition: "leftPosition",
        rightPosition: "rightPosition",
        stickyPosition: "stickyPosition",
        unfix: "unfix"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridIconsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridIconsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridIconsModule = /*#__PURE__*/(() => {
  class DxoDataGridIconsModule {
    /** @nocollapse */static ɵfac = function DxoDataGridIconsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridIconsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridIconsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridIconsComponent]
    });
  }
  return DxoDataGridIconsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridItemComponent = /*#__PURE__*/(() => {
  class DxiDataGridItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get locateInMenu() {
      return this._getOption('locateInMenu');
    }
    set locateInMenu(value) {
      this._setOption('locateInMenu', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get menuItemTemplate() {
      return this._getOption('menuItemTemplate');
    }
    set menuItemTemplate(value) {
      this._setOption('menuItemTemplate', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get showText() {
      return this._getOption('showText');
    }
    set showText(value) {
      this._setOption('showText', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get widget() {
      return this._getOption('widget');
    }
    set widget(value) {
      this._setOption('widget', value);
    }
    get _optionPath() {
      return 'items';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridItemComponent,
      selectors: [["dxi-data-grid-item"]],
      inputs: {
        cssClass: "cssClass",
        disabled: "disabled",
        html: "html",
        locateInMenu: "locateInMenu",
        location: "location",
        menuItemTemplate: "menuItemTemplate",
        name: "name",
        options: "options",
        showText: "showText",
        template: "template",
        text: "text",
        visible: "visible",
        widget: "widget"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_items,
        useExisting: DxiDataGridItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiDataGridItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiDataGridItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridItemModule = /*#__PURE__*/(() => {
  class DxiDataGridItemModule {
    /** @nocollapse */static ɵfac = function DxiDataGridItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridItemComponent]
    });
  }
  return DxiDataGridItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridKeyboardNavigationComponent = /*#__PURE__*/(() => {
  class DxoDataGridKeyboardNavigationComponent extends NestedOption {
    get editOnKeyPress() {
      return this._getOption('editOnKeyPress');
    }
    set editOnKeyPress(value) {
      this._setOption('editOnKeyPress', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get enterKeyAction() {
      return this._getOption('enterKeyAction');
    }
    set enterKeyAction(value) {
      this._setOption('enterKeyAction', value);
    }
    get enterKeyDirection() {
      return this._getOption('enterKeyDirection');
    }
    set enterKeyDirection(value) {
      this._setOption('enterKeyDirection', value);
    }
    get _optionPath() {
      return 'keyboardNavigation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridKeyboardNavigationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridKeyboardNavigationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridKeyboardNavigationComponent,
      selectors: [["dxo-data-grid-keyboard-navigation"]],
      inputs: {
        editOnKeyPress: "editOnKeyPress",
        enabled: "enabled",
        enterKeyAction: "enterKeyAction",
        enterKeyDirection: "enterKeyDirection"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridKeyboardNavigationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridKeyboardNavigationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridKeyboardNavigationModule = /*#__PURE__*/(() => {
  class DxoDataGridKeyboardNavigationModule {
    /** @nocollapse */static ɵfac = function DxoDataGridKeyboardNavigationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridKeyboardNavigationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridKeyboardNavigationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridKeyboardNavigationComponent]
    });
  }
  return DxoDataGridKeyboardNavigationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridLabelComponent = /*#__PURE__*/(() => {
  class DxoDataGridLabelComponent extends NestedOption {
    renderer;
    document;
    element;
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get showColon() {
      return this._getOption('showColon');
    }
    set showColon(value) {
      this._setOption('showColon', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridLabelComponent,
      selectors: [["dxo-data-grid-label"]],
      inputs: {
        alignment: "alignment",
        location: "location",
        showColon: "showColon",
        template: "template",
        text: "text",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoDataGridLabelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoDataGridLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridLabelModule = /*#__PURE__*/(() => {
  class DxoDataGridLabelModule {
    /** @nocollapse */static ɵfac = function DxoDataGridLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridLabelComponent]
    });
  }
  return DxoDataGridLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridLoadPanelComponent = /*#__PURE__*/(() => {
  class DxoDataGridLoadPanelComponent extends NestedOption {
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get indicatorSrc() {
      return this._getOption('indicatorSrc');
    }
    set indicatorSrc(value) {
      this._setOption('indicatorSrc', value);
    }
    get shading() {
      return this._getOption('shading');
    }
    set shading(value) {
      this._setOption('shading', value);
    }
    get shadingColor() {
      return this._getOption('shadingColor');
    }
    set shadingColor(value) {
      this._setOption('shadingColor', value);
    }
    get showIndicator() {
      return this._getOption('showIndicator');
    }
    set showIndicator(value) {
      this._setOption('showIndicator', value);
    }
    get showPane() {
      return this._getOption('showPane');
    }
    set showPane(value) {
      this._setOption('showPane', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'loadPanel';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridLoadPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridLoadPanelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridLoadPanelComponent,
      selectors: [["dxo-data-grid-load-panel"]],
      inputs: {
        enabled: "enabled",
        height: "height",
        indicatorSrc: "indicatorSrc",
        shading: "shading",
        shadingColor: "shadingColor",
        showIndicator: "showIndicator",
        showPane: "showPane",
        text: "text",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridLoadPanelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridLoadPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridLoadPanelModule = /*#__PURE__*/(() => {
  class DxoDataGridLoadPanelModule {
    /** @nocollapse */static ɵfac = function DxoDataGridLoadPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridLoadPanelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridLoadPanelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridLoadPanelComponent]
    });
  }
  return DxoDataGridLoadPanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridLookupComponent = /*#__PURE__*/(() => {
  class DxoDataGridLookupComponent extends NestedOption {
    get allowClearing() {
      return this._getOption('allowClearing');
    }
    set allowClearing(value) {
      this._setOption('allowClearing', value);
    }
    get calculateCellValue() {
      return this._getOption('calculateCellValue');
    }
    set calculateCellValue(value) {
      this._setOption('calculateCellValue', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get displayExpr() {
      return this._getOption('displayExpr');
    }
    set displayExpr(value) {
      this._setOption('displayExpr', value);
    }
    get valueExpr() {
      return this._getOption('valueExpr');
    }
    set valueExpr(value) {
      this._setOption('valueExpr', value);
    }
    get _optionPath() {
      return 'lookup';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridLookupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridLookupComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridLookupComponent,
      selectors: [["dxo-data-grid-lookup"]],
      inputs: {
        allowClearing: "allowClearing",
        calculateCellValue: "calculateCellValue",
        dataSource: "dataSource",
        displayExpr: "displayExpr",
        valueExpr: "valueExpr"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridLookupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridLookupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridLookupModule = /*#__PURE__*/(() => {
  class DxoDataGridLookupModule {
    /** @nocollapse */static ɵfac = function DxoDataGridLookupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridLookupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridLookupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridLookupComponent]
    });
  }
  return DxoDataGridLookupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridMasterDetailComponent = /*#__PURE__*/(() => {
  class DxoDataGridMasterDetailComponent extends NestedOption {
    renderer;
    document;
    element;
    get autoExpandAll() {
      return this._getOption('autoExpandAll');
    }
    set autoExpandAll(value) {
      this._setOption('autoExpandAll', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get _optionPath() {
      return 'masterDetail';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridMasterDetailComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridMasterDetailComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridMasterDetailComponent,
      selectors: [["dxo-data-grid-master-detail"]],
      inputs: {
        autoExpandAll: "autoExpandAll",
        enabled: "enabled",
        template: "template"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoDataGridMasterDetailComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoDataGridMasterDetailComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridMasterDetailModule = /*#__PURE__*/(() => {
  class DxoDataGridMasterDetailModule {
    /** @nocollapse */static ɵfac = function DxoDataGridMasterDetailModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridMasterDetailModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridMasterDetailModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridMasterDetailComponent]
    });
  }
  return DxoDataGridMasterDetailModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridMyComponent = /*#__PURE__*/(() => {
  class DxoDataGridMyComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'my';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridMyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridMyComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridMyComponent,
      selectors: [["dxo-data-grid-my"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridMyComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridMyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridMyModule = /*#__PURE__*/(() => {
  class DxoDataGridMyModule {
    /** @nocollapse */static ɵfac = function DxoDataGridMyModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridMyModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridMyModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridMyComponent]
    });
  }
  return DxoDataGridMyModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridNumericRuleComponent = /*#__PURE__*/(() => {
  class DxiDataGridNumericRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'numeric';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridNumericRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridNumericRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridNumericRuleComponent,
      selectors: [["dxi-data-grid-numeric-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        message: "message",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiDataGridNumericRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridNumericRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridNumericRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridNumericRuleModule = /*#__PURE__*/(() => {
  class DxiDataGridNumericRuleModule {
    /** @nocollapse */static ɵfac = function DxiDataGridNumericRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridNumericRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridNumericRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridNumericRuleComponent]
    });
  }
  return DxiDataGridNumericRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridOffsetComponent = /*#__PURE__*/(() => {
  class DxoDataGridOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'offset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridOffsetComponent,
      selectors: [["dxo-data-grid-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridOffsetComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridOffsetModule = /*#__PURE__*/(() => {
  class DxoDataGridOffsetModule {
    /** @nocollapse */static ɵfac = function DxoDataGridOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridOffsetComponent]
    });
  }
  return DxoDataGridOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridOperationDescriptionsComponent = /*#__PURE__*/(() => {
  class DxoDataGridOperationDescriptionsComponent extends NestedOption {
    get between() {
      return this._getOption('between');
    }
    set between(value) {
      this._setOption('between', value);
    }
    get contains() {
      return this._getOption('contains');
    }
    set contains(value) {
      this._setOption('contains', value);
    }
    get endsWith() {
      return this._getOption('endsWith');
    }
    set endsWith(value) {
      this._setOption('endsWith', value);
    }
    get equal() {
      return this._getOption('equal');
    }
    set equal(value) {
      this._setOption('equal', value);
    }
    get greaterThan() {
      return this._getOption('greaterThan');
    }
    set greaterThan(value) {
      this._setOption('greaterThan', value);
    }
    get greaterThanOrEqual() {
      return this._getOption('greaterThanOrEqual');
    }
    set greaterThanOrEqual(value) {
      this._setOption('greaterThanOrEqual', value);
    }
    get lessThan() {
      return this._getOption('lessThan');
    }
    set lessThan(value) {
      this._setOption('lessThan', value);
    }
    get lessThanOrEqual() {
      return this._getOption('lessThanOrEqual');
    }
    set lessThanOrEqual(value) {
      this._setOption('lessThanOrEqual', value);
    }
    get notContains() {
      return this._getOption('notContains');
    }
    set notContains(value) {
      this._setOption('notContains', value);
    }
    get notEqual() {
      return this._getOption('notEqual');
    }
    set notEqual(value) {
      this._setOption('notEqual', value);
    }
    get startsWith() {
      return this._getOption('startsWith');
    }
    set startsWith(value) {
      this._setOption('startsWith', value);
    }
    get _optionPath() {
      return 'operationDescriptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridOperationDescriptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridOperationDescriptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridOperationDescriptionsComponent,
      selectors: [["dxo-data-grid-operation-descriptions"]],
      inputs: {
        between: "between",
        contains: "contains",
        endsWith: "endsWith",
        equal: "equal",
        greaterThan: "greaterThan",
        greaterThanOrEqual: "greaterThanOrEqual",
        lessThan: "lessThan",
        lessThanOrEqual: "lessThanOrEqual",
        notContains: "notContains",
        notEqual: "notEqual",
        startsWith: "startsWith"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridOperationDescriptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridOperationDescriptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridOperationDescriptionsModule = /*#__PURE__*/(() => {
  class DxoDataGridOperationDescriptionsModule {
    /** @nocollapse */static ɵfac = function DxoDataGridOperationDescriptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridOperationDescriptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridOperationDescriptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridOperationDescriptionsComponent]
    });
  }
  return DxoDataGridOperationDescriptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridPagerComponent = /*#__PURE__*/(() => {
  class DxoDataGridPagerComponent extends NestedOption {
    get allowedPageSizes() {
      return this._getOption('allowedPageSizes');
    }
    set allowedPageSizes(value) {
      this._setOption('allowedPageSizes', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get infoText() {
      return this._getOption('infoText');
    }
    set infoText(value) {
      this._setOption('infoText', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get showInfo() {
      return this._getOption('showInfo');
    }
    set showInfo(value) {
      this._setOption('showInfo', value);
    }
    get showNavigationButtons() {
      return this._getOption('showNavigationButtons');
    }
    set showNavigationButtons(value) {
      this._setOption('showNavigationButtons', value);
    }
    get showPageSizeSelector() {
      return this._getOption('showPageSizeSelector');
    }
    set showPageSizeSelector(value) {
      this._setOption('showPageSizeSelector', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'pager';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridPagerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridPagerComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridPagerComponent,
      selectors: [["dxo-data-grid-pager"]],
      inputs: {
        allowedPageSizes: "allowedPageSizes",
        displayMode: "displayMode",
        infoText: "infoText",
        label: "label",
        showInfo: "showInfo",
        showNavigationButtons: "showNavigationButtons",
        showPageSizeSelector: "showPageSizeSelector",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridPagerComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridPagerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridPagerModule = /*#__PURE__*/(() => {
  class DxoDataGridPagerModule {
    /** @nocollapse */static ɵfac = function DxoDataGridPagerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridPagerModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridPagerModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridPagerComponent]
    });
  }
  return DxoDataGridPagerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridPagingComponent = /*#__PURE__*/(() => {
  class DxoDataGridPagingComponent extends NestedOption {
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get pageIndex() {
      return this._getOption('pageIndex');
    }
    set pageIndex(value) {
      this._setOption('pageIndex', value);
    }
    get pageSize() {
      return this._getOption('pageSize');
    }
    set pageSize(value) {
      this._setOption('pageSize', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    pageIndexChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    pageSizeChange;
    get _optionPath() {
      return 'paging';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'pageIndexChange'
      }, {
        emit: 'pageSizeChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridPagingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridPagingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridPagingComponent,
      selectors: [["dxo-data-grid-paging"]],
      inputs: {
        enabled: "enabled",
        pageIndex: "pageIndex",
        pageSize: "pageSize"
      },
      outputs: {
        pageIndexChange: "pageIndexChange",
        pageSizeChange: "pageSizeChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridPagingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridPagingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridPagingModule = /*#__PURE__*/(() => {
  class DxoDataGridPagingModule {
    /** @nocollapse */static ɵfac = function DxoDataGridPagingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridPagingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridPagingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridPagingComponent]
    });
  }
  return DxoDataGridPagingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridPatternRuleComponent = /*#__PURE__*/(() => {
  class DxiDataGridPatternRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get pattern() {
      return this._getOption('pattern');
    }
    set pattern(value) {
      this._setOption('pattern', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'pattern';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridPatternRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridPatternRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridPatternRuleComponent,
      selectors: [["dxi-data-grid-pattern-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        message: "message",
        pattern: "pattern",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiDataGridPatternRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridPatternRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridPatternRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridPatternRuleModule = /*#__PURE__*/(() => {
  class DxiDataGridPatternRuleModule {
    /** @nocollapse */static ɵfac = function DxiDataGridPatternRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridPatternRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridPatternRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridPatternRuleComponent]
    });
  }
  return DxiDataGridPatternRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridPopupComponent = /*#__PURE__*/(() => {
  class DxoDataGridPopupComponent extends NestedOption {
    set _toolbarItemsContentChildren(value) {
      this.setChildren('toolbarItems', value);
    }
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get animation() {
      return this._getOption('animation');
    }
    set animation(value) {
      this._setOption('animation', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get contentTemplate() {
      return this._getOption('contentTemplate');
    }
    set contentTemplate(value) {
      this._setOption('contentTemplate', value);
    }
    get deferRendering() {
      return this._getOption('deferRendering');
    }
    set deferRendering(value) {
      this._setOption('deferRendering', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get dragAndResizeArea() {
      return this._getOption('dragAndResizeArea');
    }
    set dragAndResizeArea(value) {
      this._setOption('dragAndResizeArea', value);
    }
    get dragEnabled() {
      return this._getOption('dragEnabled');
    }
    set dragEnabled(value) {
      this._setOption('dragEnabled', value);
    }
    get dragOutsideBoundary() {
      return this._getOption('dragOutsideBoundary');
    }
    set dragOutsideBoundary(value) {
      this._setOption('dragOutsideBoundary', value);
    }
    get enableBodyScroll() {
      return this._getOption('enableBodyScroll');
    }
    set enableBodyScroll(value) {
      this._setOption('enableBodyScroll', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get fullScreen() {
      return this._getOption('fullScreen');
    }
    set fullScreen(value) {
      this._setOption('fullScreen', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hideOnOutsideClick() {
      return this._getOption('hideOnOutsideClick');
    }
    set hideOnOutsideClick(value) {
      this._setOption('hideOnOutsideClick', value);
    }
    get hideOnParentScroll() {
      return this._getOption('hideOnParentScroll');
    }
    set hideOnParentScroll(value) {
      this._setOption('hideOnParentScroll', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get maxHeight() {
      return this._getOption('maxHeight');
    }
    set maxHeight(value) {
      this._setOption('maxHeight', value);
    }
    get maxWidth() {
      return this._getOption('maxWidth');
    }
    set maxWidth(value) {
      this._setOption('maxWidth', value);
    }
    get minHeight() {
      return this._getOption('minHeight');
    }
    set minHeight(value) {
      this._setOption('minHeight', value);
    }
    get minWidth() {
      return this._getOption('minWidth');
    }
    set minWidth(value) {
      this._setOption('minWidth', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onHidden() {
      return this._getOption('onHidden');
    }
    set onHidden(value) {
      this._setOption('onHidden', value);
    }
    get onHiding() {
      return this._getOption('onHiding');
    }
    set onHiding(value) {
      this._setOption('onHiding', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onResize() {
      return this._getOption('onResize');
    }
    set onResize(value) {
      this._setOption('onResize', value);
    }
    get onResizeEnd() {
      return this._getOption('onResizeEnd');
    }
    set onResizeEnd(value) {
      this._setOption('onResizeEnd', value);
    }
    get onResizeStart() {
      return this._getOption('onResizeStart');
    }
    set onResizeStart(value) {
      this._setOption('onResizeStart', value);
    }
    get onShowing() {
      return this._getOption('onShowing');
    }
    set onShowing(value) {
      this._setOption('onShowing', value);
    }
    get onShown() {
      return this._getOption('onShown');
    }
    set onShown(value) {
      this._setOption('onShown', value);
    }
    get onTitleRendered() {
      return this._getOption('onTitleRendered');
    }
    set onTitleRendered(value) {
      this._setOption('onTitleRendered', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get resizeEnabled() {
      return this._getOption('resizeEnabled');
    }
    set resizeEnabled(value) {
      this._setOption('resizeEnabled', value);
    }
    get restorePosition() {
      return this._getOption('restorePosition');
    }
    set restorePosition(value) {
      this._setOption('restorePosition', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get shading() {
      return this._getOption('shading');
    }
    set shading(value) {
      this._setOption('shading', value);
    }
    get shadingColor() {
      return this._getOption('shadingColor');
    }
    set shadingColor(value) {
      this._setOption('shadingColor', value);
    }
    get showCloseButton() {
      return this._getOption('showCloseButton');
    }
    set showCloseButton(value) {
      this._setOption('showCloseButton', value);
    }
    get showTitle() {
      return this._getOption('showTitle');
    }
    set showTitle(value) {
      this._setOption('showTitle', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get titleTemplate() {
      return this._getOption('titleTemplate');
    }
    set titleTemplate(value) {
      this._setOption('titleTemplate', value);
    }
    get toolbarItems() {
      return this._getOption('toolbarItems');
    }
    set toolbarItems(value) {
      this._setOption('toolbarItems', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wrapperAttr() {
      return this._getOption('wrapperAttr');
    }
    set wrapperAttr(value) {
      this._setOption('wrapperAttr', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    positionChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    get _optionPath() {
      return 'popup';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'heightChange'
      }, {
        emit: 'positionChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'widthChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridPopupComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridPopupComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridPopupComponent,
      selectors: [["dxo-data-grid-popup"]],
      contentQueries: function DxoDataGridPopupComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_toolbarItems, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._toolbarItemsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        animation: "animation",
        container: "container",
        contentTemplate: "contentTemplate",
        deferRendering: "deferRendering",
        disabled: "disabled",
        dragAndResizeArea: "dragAndResizeArea",
        dragEnabled: "dragEnabled",
        dragOutsideBoundary: "dragOutsideBoundary",
        enableBodyScroll: "enableBodyScroll",
        focusStateEnabled: "focusStateEnabled",
        fullScreen: "fullScreen",
        height: "height",
        hideOnOutsideClick: "hideOnOutsideClick",
        hideOnParentScroll: "hideOnParentScroll",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        maxHeight: "maxHeight",
        maxWidth: "maxWidth",
        minHeight: "minHeight",
        minWidth: "minWidth",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onHidden: "onHidden",
        onHiding: "onHiding",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onResize: "onResize",
        onResizeEnd: "onResizeEnd",
        onResizeStart: "onResizeStart",
        onShowing: "onShowing",
        onShown: "onShown",
        onTitleRendered: "onTitleRendered",
        position: "position",
        resizeEnabled: "resizeEnabled",
        restorePosition: "restorePosition",
        rtlEnabled: "rtlEnabled",
        shading: "shading",
        shadingColor: "shadingColor",
        showCloseButton: "showCloseButton",
        showTitle: "showTitle",
        tabIndex: "tabIndex",
        title: "title",
        titleTemplate: "titleTemplate",
        toolbarItems: "toolbarItems",
        visible: "visible",
        width: "width",
        wrapperAttr: "wrapperAttr"
      },
      outputs: {
        heightChange: "heightChange",
        positionChange: "positionChange",
        visibleChange: "visibleChange",
        widthChange: "widthChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridPopupComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridPopupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridPopupModule = /*#__PURE__*/(() => {
  class DxoDataGridPopupModule {
    /** @nocollapse */static ɵfac = function DxoDataGridPopupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridPopupModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridPopupModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridPopupComponent]
    });
  }
  return DxoDataGridPopupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridPositionComponent = /*#__PURE__*/(() => {
  class DxoDataGridPositionComponent extends NestedOption {
    get at() {
      return this._getOption('at');
    }
    set at(value) {
      this._setOption('at', value);
    }
    get boundary() {
      return this._getOption('boundary');
    }
    set boundary(value) {
      this._setOption('boundary', value);
    }
    get boundaryOffset() {
      return this._getOption('boundaryOffset');
    }
    set boundaryOffset(value) {
      this._setOption('boundaryOffset', value);
    }
    get collision() {
      return this._getOption('collision');
    }
    set collision(value) {
      this._setOption('collision', value);
    }
    get my() {
      return this._getOption('my');
    }
    set my(value) {
      this._setOption('my', value);
    }
    get of() {
      return this._getOption('of');
    }
    set of(value) {
      this._setOption('of', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get _optionPath() {
      return 'position';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridPositionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridPositionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridPositionComponent,
      selectors: [["dxo-data-grid-position"]],
      inputs: {
        at: "at",
        boundary: "boundary",
        boundaryOffset: "boundaryOffset",
        collision: "collision",
        my: "my",
        of: "of",
        offset: "offset"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridPositionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridPositionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridPositionModule = /*#__PURE__*/(() => {
  class DxoDataGridPositionModule {
    /** @nocollapse */static ɵfac = function DxoDataGridPositionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridPositionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridPositionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridPositionComponent]
    });
  }
  return DxoDataGridPositionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridRangeRuleComponent = /*#__PURE__*/(() => {
  class DxiDataGridRangeRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get max() {
      return this._getOption('max');
    }
    set max(value) {
      this._setOption('max', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get min() {
      return this._getOption('min');
    }
    set min(value) {
      this._setOption('min', value);
    }
    get reevaluate() {
      return this._getOption('reevaluate');
    }
    set reevaluate(value) {
      this._setOption('reevaluate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'range';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridRangeRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridRangeRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridRangeRuleComponent,
      selectors: [["dxi-data-grid-range-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        max: "max",
        message: "message",
        min: "min",
        reevaluate: "reevaluate",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiDataGridRangeRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridRangeRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridRangeRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridRangeRuleModule = /*#__PURE__*/(() => {
  class DxiDataGridRangeRuleModule {
    /** @nocollapse */static ɵfac = function DxiDataGridRangeRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridRangeRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridRangeRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridRangeRuleComponent]
    });
  }
  return DxiDataGridRangeRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridRemoteOperationsComponent = /*#__PURE__*/(() => {
  class DxoDataGridRemoteOperationsComponent extends NestedOption {
    get filtering() {
      return this._getOption('filtering');
    }
    set filtering(value) {
      this._setOption('filtering', value);
    }
    get grouping() {
      return this._getOption('grouping');
    }
    set grouping(value) {
      this._setOption('grouping', value);
    }
    get groupPaging() {
      return this._getOption('groupPaging');
    }
    set groupPaging(value) {
      this._setOption('groupPaging', value);
    }
    get paging() {
      return this._getOption('paging');
    }
    set paging(value) {
      this._setOption('paging', value);
    }
    get sorting() {
      return this._getOption('sorting');
    }
    set sorting(value) {
      this._setOption('sorting', value);
    }
    get summary() {
      return this._getOption('summary');
    }
    set summary(value) {
      this._setOption('summary', value);
    }
    get _optionPath() {
      return 'remoteOperations';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridRemoteOperationsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridRemoteOperationsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridRemoteOperationsComponent,
      selectors: [["dxo-data-grid-remote-operations"]],
      inputs: {
        filtering: "filtering",
        grouping: "grouping",
        groupPaging: "groupPaging",
        paging: "paging",
        sorting: "sorting",
        summary: "summary"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridRemoteOperationsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridRemoteOperationsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridRemoteOperationsModule = /*#__PURE__*/(() => {
  class DxoDataGridRemoteOperationsModule {
    /** @nocollapse */static ɵfac = function DxoDataGridRemoteOperationsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridRemoteOperationsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridRemoteOperationsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridRemoteOperationsComponent]
    });
  }
  return DxoDataGridRemoteOperationsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridRequiredRuleComponent = /*#__PURE__*/(() => {
  class DxiDataGridRequiredRuleComponent extends CollectionNestedOption {
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get trim() {
      return this._getOption('trim');
    }
    set trim(value) {
      this._setOption('trim', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'required';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridRequiredRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridRequiredRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridRequiredRuleComponent,
      selectors: [["dxi-data-grid-required-rule"]],
      inputs: {
        message: "message",
        trim: "trim",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiDataGridRequiredRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridRequiredRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridRequiredRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridRequiredRuleModule = /*#__PURE__*/(() => {
  class DxiDataGridRequiredRuleModule {
    /** @nocollapse */static ɵfac = function DxiDataGridRequiredRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridRequiredRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridRequiredRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridRequiredRuleComponent]
    });
  }
  return DxiDataGridRequiredRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridRowDraggingComponent = /*#__PURE__*/(() => {
  class DxoDataGridRowDraggingComponent extends NestedOption {
    get allowDropInsideItem() {
      return this._getOption('allowDropInsideItem');
    }
    set allowDropInsideItem(value) {
      this._setOption('allowDropInsideItem', value);
    }
    get allowReordering() {
      return this._getOption('allowReordering');
    }
    set allowReordering(value) {
      this._setOption('allowReordering', value);
    }
    get autoScroll() {
      return this._getOption('autoScroll');
    }
    set autoScroll(value) {
      this._setOption('autoScroll', value);
    }
    get boundary() {
      return this._getOption('boundary');
    }
    set boundary(value) {
      this._setOption('boundary', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get cursorOffset() {
      return this._getOption('cursorOffset');
    }
    set cursorOffset(value) {
      this._setOption('cursorOffset', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get dragDirection() {
      return this._getOption('dragDirection');
    }
    set dragDirection(value) {
      this._setOption('dragDirection', value);
    }
    get dragTemplate() {
      return this._getOption('dragTemplate');
    }
    set dragTemplate(value) {
      this._setOption('dragTemplate', value);
    }
    get dropFeedbackMode() {
      return this._getOption('dropFeedbackMode');
    }
    set dropFeedbackMode(value) {
      this._setOption('dropFeedbackMode', value);
    }
    get filter() {
      return this._getOption('filter');
    }
    set filter(value) {
      this._setOption('filter', value);
    }
    get group() {
      return this._getOption('group');
    }
    set group(value) {
      this._setOption('group', value);
    }
    get handle() {
      return this._getOption('handle');
    }
    set handle(value) {
      this._setOption('handle', value);
    }
    get onAdd() {
      return this._getOption('onAdd');
    }
    set onAdd(value) {
      this._setOption('onAdd', value);
    }
    get onDragChange() {
      return this._getOption('onDragChange');
    }
    set onDragChange(value) {
      this._setOption('onDragChange', value);
    }
    get onDragEnd() {
      return this._getOption('onDragEnd');
    }
    set onDragEnd(value) {
      this._setOption('onDragEnd', value);
    }
    get onDragMove() {
      return this._getOption('onDragMove');
    }
    set onDragMove(value) {
      this._setOption('onDragMove', value);
    }
    get onDragStart() {
      return this._getOption('onDragStart');
    }
    set onDragStart(value) {
      this._setOption('onDragStart', value);
    }
    get onRemove() {
      return this._getOption('onRemove');
    }
    set onRemove(value) {
      this._setOption('onRemove', value);
    }
    get onReorder() {
      return this._getOption('onReorder');
    }
    set onReorder(value) {
      this._setOption('onReorder', value);
    }
    get scrollSensitivity() {
      return this._getOption('scrollSensitivity');
    }
    set scrollSensitivity(value) {
      this._setOption('scrollSensitivity', value);
    }
    get scrollSpeed() {
      return this._getOption('scrollSpeed');
    }
    set scrollSpeed(value) {
      this._setOption('scrollSpeed', value);
    }
    get showDragIcons() {
      return this._getOption('showDragIcons');
    }
    set showDragIcons(value) {
      this._setOption('showDragIcons', value);
    }
    get _optionPath() {
      return 'rowDragging';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridRowDraggingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridRowDraggingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridRowDraggingComponent,
      selectors: [["dxo-data-grid-row-dragging"]],
      inputs: {
        allowDropInsideItem: "allowDropInsideItem",
        allowReordering: "allowReordering",
        autoScroll: "autoScroll",
        boundary: "boundary",
        container: "container",
        cursorOffset: "cursorOffset",
        data: "data",
        dragDirection: "dragDirection",
        dragTemplate: "dragTemplate",
        dropFeedbackMode: "dropFeedbackMode",
        filter: "filter",
        group: "group",
        handle: "handle",
        onAdd: "onAdd",
        onDragChange: "onDragChange",
        onDragEnd: "onDragEnd",
        onDragMove: "onDragMove",
        onDragStart: "onDragStart",
        onRemove: "onRemove",
        onReorder: "onReorder",
        scrollSensitivity: "scrollSensitivity",
        scrollSpeed: "scrollSpeed",
        showDragIcons: "showDragIcons"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridRowDraggingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridRowDraggingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridRowDraggingModule = /*#__PURE__*/(() => {
  class DxoDataGridRowDraggingModule {
    /** @nocollapse */static ɵfac = function DxoDataGridRowDraggingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridRowDraggingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridRowDraggingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridRowDraggingComponent]
    });
  }
  return DxoDataGridRowDraggingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridScrollingComponent = /*#__PURE__*/(() => {
  class DxoDataGridScrollingComponent extends NestedOption {
    get columnRenderingMode() {
      return this._getOption('columnRenderingMode');
    }
    set columnRenderingMode(value) {
      this._setOption('columnRenderingMode', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get preloadEnabled() {
      return this._getOption('preloadEnabled');
    }
    set preloadEnabled(value) {
      this._setOption('preloadEnabled', value);
    }
    get renderAsync() {
      return this._getOption('renderAsync');
    }
    set renderAsync(value) {
      this._setOption('renderAsync', value);
    }
    get rowRenderingMode() {
      return this._getOption('rowRenderingMode');
    }
    set rowRenderingMode(value) {
      this._setOption('rowRenderingMode', value);
    }
    get scrollByContent() {
      return this._getOption('scrollByContent');
    }
    set scrollByContent(value) {
      this._setOption('scrollByContent', value);
    }
    get scrollByThumb() {
      return this._getOption('scrollByThumb');
    }
    set scrollByThumb(value) {
      this._setOption('scrollByThumb', value);
    }
    get showScrollbar() {
      return this._getOption('showScrollbar');
    }
    set showScrollbar(value) {
      this._setOption('showScrollbar', value);
    }
    get useNative() {
      return this._getOption('useNative');
    }
    set useNative(value) {
      this._setOption('useNative', value);
    }
    get _optionPath() {
      return 'scrolling';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridScrollingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridScrollingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridScrollingComponent,
      selectors: [["dxo-data-grid-scrolling"]],
      inputs: {
        columnRenderingMode: "columnRenderingMode",
        mode: "mode",
        preloadEnabled: "preloadEnabled",
        renderAsync: "renderAsync",
        rowRenderingMode: "rowRenderingMode",
        scrollByContent: "scrollByContent",
        scrollByThumb: "scrollByThumb",
        showScrollbar: "showScrollbar",
        useNative: "useNative"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridScrollingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridScrollingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridScrollingModule = /*#__PURE__*/(() => {
  class DxoDataGridScrollingModule {
    /** @nocollapse */static ɵfac = function DxoDataGridScrollingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridScrollingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridScrollingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridScrollingComponent]
    });
  }
  return DxoDataGridScrollingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridSearchPanelComponent = /*#__PURE__*/(() => {
  class DxoDataGridSearchPanelComponent extends NestedOption {
    get highlightCaseSensitive() {
      return this._getOption('highlightCaseSensitive');
    }
    set highlightCaseSensitive(value) {
      this._setOption('highlightCaseSensitive', value);
    }
    get highlightSearchText() {
      return this._getOption('highlightSearchText');
    }
    set highlightSearchText(value) {
      this._setOption('highlightSearchText', value);
    }
    get placeholder() {
      return this._getOption('placeholder');
    }
    set placeholder(value) {
      this._setOption('placeholder', value);
    }
    get searchVisibleColumnsOnly() {
      return this._getOption('searchVisibleColumnsOnly');
    }
    set searchVisibleColumnsOnly(value) {
      this._setOption('searchVisibleColumnsOnly', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    textChange;
    get _optionPath() {
      return 'searchPanel';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'textChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridSearchPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridSearchPanelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridSearchPanelComponent,
      selectors: [["dxo-data-grid-search-panel"]],
      inputs: {
        highlightCaseSensitive: "highlightCaseSensitive",
        highlightSearchText: "highlightSearchText",
        placeholder: "placeholder",
        searchVisibleColumnsOnly: "searchVisibleColumnsOnly",
        text: "text",
        visible: "visible",
        width: "width"
      },
      outputs: {
        textChange: "textChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridSearchPanelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridSearchPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridSearchPanelModule = /*#__PURE__*/(() => {
  class DxoDataGridSearchPanelModule {
    /** @nocollapse */static ɵfac = function DxoDataGridSearchPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridSearchPanelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridSearchPanelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridSearchPanelComponent]
    });
  }
  return DxoDataGridSearchPanelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridSearchComponent = /*#__PURE__*/(() => {
  class DxoDataGridSearchComponent extends NestedOption {
    get editorOptions() {
      return this._getOption('editorOptions');
    }
    set editorOptions(value) {
      this._setOption('editorOptions', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get searchExpr() {
      return this._getOption('searchExpr');
    }
    set searchExpr(value) {
      this._setOption('searchExpr', value);
    }
    get timeout() {
      return this._getOption('timeout');
    }
    set timeout(value) {
      this._setOption('timeout', value);
    }
    get _optionPath() {
      return 'search';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridSearchComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridSearchComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridSearchComponent,
      selectors: [["dxo-data-grid-search"]],
      inputs: {
        editorOptions: "editorOptions",
        enabled: "enabled",
        mode: "mode",
        searchExpr: "searchExpr",
        timeout: "timeout"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridSearchComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridSearchModule = /*#__PURE__*/(() => {
  class DxoDataGridSearchModule {
    /** @nocollapse */static ɵfac = function DxoDataGridSearchModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridSearchModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridSearchModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridSearchComponent]
    });
  }
  return DxoDataGridSearchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridSelectionComponent = /*#__PURE__*/(() => {
  class DxoDataGridSelectionComponent extends NestedOption {
    get allowSelectAll() {
      return this._getOption('allowSelectAll');
    }
    set allowSelectAll(value) {
      this._setOption('allowSelectAll', value);
    }
    get deferred() {
      return this._getOption('deferred');
    }
    set deferred(value) {
      this._setOption('deferred', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get selectAllMode() {
      return this._getOption('selectAllMode');
    }
    set selectAllMode(value) {
      this._setOption('selectAllMode', value);
    }
    get sensitivity() {
      return this._getOption('sensitivity');
    }
    set sensitivity(value) {
      this._setOption('sensitivity', value);
    }
    get showCheckBoxesMode() {
      return this._getOption('showCheckBoxesMode');
    }
    set showCheckBoxesMode(value) {
      this._setOption('showCheckBoxesMode', value);
    }
    get recursive() {
      return this._getOption('recursive');
    }
    set recursive(value) {
      this._setOption('recursive', value);
    }
    get selectByClick() {
      return this._getOption('selectByClick');
    }
    set selectByClick(value) {
      this._setOption('selectByClick', value);
    }
    get _optionPath() {
      return 'selection';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridSelectionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridSelectionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridSelectionComponent,
      selectors: [["dxo-data-grid-selection"]],
      inputs: {
        allowSelectAll: "allowSelectAll",
        deferred: "deferred",
        mode: "mode",
        selectAllMode: "selectAllMode",
        sensitivity: "sensitivity",
        showCheckBoxesMode: "showCheckBoxesMode",
        recursive: "recursive",
        selectByClick: "selectByClick"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridSelectionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridSelectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridSelectionModule = /*#__PURE__*/(() => {
  class DxoDataGridSelectionModule {
    /** @nocollapse */static ɵfac = function DxoDataGridSelectionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridSelectionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridSelectionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridSelectionComponent]
    });
  }
  return DxoDataGridSelectionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridShowComponent = /*#__PURE__*/(() => {
  class DxoDataGridShowComponent extends NestedOption {
    get complete() {
      return this._getOption('complete');
    }
    set complete(value) {
      this._setOption('complete', value);
    }
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get staggerDelay() {
      return this._getOption('staggerDelay');
    }
    set staggerDelay(value) {
      this._setOption('staggerDelay', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'show';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridShowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridShowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridShowComponent,
      selectors: [["dxo-data-grid-show"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridShowComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridShowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridShowModule = /*#__PURE__*/(() => {
  class DxoDataGridShowModule {
    /** @nocollapse */static ɵfac = function DxoDataGridShowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridShowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridShowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridShowComponent]
    });
  }
  return DxoDataGridShowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridSortByGroupSummaryInfoComponent = /*#__PURE__*/(() => {
  class DxiDataGridSortByGroupSummaryInfoComponent extends CollectionNestedOption {
    get groupColumn() {
      return this._getOption('groupColumn');
    }
    set groupColumn(value) {
      this._setOption('groupColumn', value);
    }
    get sortOrder() {
      return this._getOption('sortOrder');
    }
    set sortOrder(value) {
      this._setOption('sortOrder', value);
    }
    get summaryItem() {
      return this._getOption('summaryItem');
    }
    set summaryItem(value) {
      this._setOption('summaryItem', value);
    }
    get _optionPath() {
      return 'sortByGroupSummaryInfo';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridSortByGroupSummaryInfoComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridSortByGroupSummaryInfoComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridSortByGroupSummaryInfoComponent,
      selectors: [["dxi-data-grid-sort-by-group-summary-info"]],
      inputs: {
        groupColumn: "groupColumn",
        sortOrder: "sortOrder",
        summaryItem: "summaryItem"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_sortByGroupSummaryInfo,
        useExisting: DxiDataGridSortByGroupSummaryInfoComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridSortByGroupSummaryInfoComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridSortByGroupSummaryInfoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridSortByGroupSummaryInfoModule = /*#__PURE__*/(() => {
  class DxiDataGridSortByGroupSummaryInfoModule {
    /** @nocollapse */static ɵfac = function DxiDataGridSortByGroupSummaryInfoModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridSortByGroupSummaryInfoModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridSortByGroupSummaryInfoModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridSortByGroupSummaryInfoComponent]
    });
  }
  return DxiDataGridSortByGroupSummaryInfoModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridSortingComponent = /*#__PURE__*/(() => {
  class DxoDataGridSortingComponent extends NestedOption {
    get ascendingText() {
      return this._getOption('ascendingText');
    }
    set ascendingText(value) {
      this._setOption('ascendingText', value);
    }
    get clearText() {
      return this._getOption('clearText');
    }
    set clearText(value) {
      this._setOption('clearText', value);
    }
    get descendingText() {
      return this._getOption('descendingText');
    }
    set descendingText(value) {
      this._setOption('descendingText', value);
    }
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get showSortIndexes() {
      return this._getOption('showSortIndexes');
    }
    set showSortIndexes(value) {
      this._setOption('showSortIndexes', value);
    }
    get _optionPath() {
      return 'sorting';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridSortingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridSortingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridSortingComponent,
      selectors: [["dxo-data-grid-sorting"]],
      inputs: {
        ascendingText: "ascendingText",
        clearText: "clearText",
        descendingText: "descendingText",
        mode: "mode",
        showSortIndexes: "showSortIndexes"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridSortingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridSortingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridSortingModule = /*#__PURE__*/(() => {
  class DxoDataGridSortingModule {
    /** @nocollapse */static ɵfac = function DxoDataGridSortingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridSortingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridSortingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridSortingComponent]
    });
  }
  return DxoDataGridSortingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridStateStoringComponent = /*#__PURE__*/(() => {
  class DxoDataGridStateStoringComponent extends NestedOption {
    get customLoad() {
      return this._getOption('customLoad');
    }
    set customLoad(value) {
      this._setOption('customLoad', value);
    }
    get customSave() {
      return this._getOption('customSave');
    }
    set customSave(value) {
      this._setOption('customSave', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get savingTimeout() {
      return this._getOption('savingTimeout');
    }
    set savingTimeout(value) {
      this._setOption('savingTimeout', value);
    }
    get storageKey() {
      return this._getOption('storageKey');
    }
    set storageKey(value) {
      this._setOption('storageKey', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'stateStoring';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridStateStoringComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridStateStoringComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridStateStoringComponent,
      selectors: [["dxo-data-grid-state-storing"]],
      inputs: {
        customLoad: "customLoad",
        customSave: "customSave",
        enabled: "enabled",
        savingTimeout: "savingTimeout",
        storageKey: "storageKey",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridStateStoringComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridStateStoringComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridStateStoringModule = /*#__PURE__*/(() => {
  class DxoDataGridStateStoringModule {
    /** @nocollapse */static ɵfac = function DxoDataGridStateStoringModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridStateStoringModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridStateStoringModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridStateStoringComponent]
    });
  }
  return DxoDataGridStateStoringModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridStringLengthRuleComponent = /*#__PURE__*/(() => {
  class DxiDataGridStringLengthRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get max() {
      return this._getOption('max');
    }
    set max(value) {
      this._setOption('max', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get min() {
      return this._getOption('min');
    }
    set min(value) {
      this._setOption('min', value);
    }
    get trim() {
      return this._getOption('trim');
    }
    set trim(value) {
      this._setOption('trim', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'stringLength';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridStringLengthRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridStringLengthRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridStringLengthRuleComponent,
      selectors: [["dxi-data-grid-string-length-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        max: "max",
        message: "message",
        min: "min",
        trim: "trim",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiDataGridStringLengthRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridStringLengthRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridStringLengthRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridStringLengthRuleModule = /*#__PURE__*/(() => {
  class DxiDataGridStringLengthRuleModule {
    /** @nocollapse */static ɵfac = function DxiDataGridStringLengthRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridStringLengthRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridStringLengthRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridStringLengthRuleComponent]
    });
  }
  return DxiDataGridStringLengthRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridSummaryTextsComponent = /*#__PURE__*/(() => {
  class DxoDataGridSummaryTextsComponent extends NestedOption {
    get avg() {
      return this._getOption('avg');
    }
    set avg(value) {
      this._setOption('avg', value);
    }
    get avgOtherColumn() {
      return this._getOption('avgOtherColumn');
    }
    set avgOtherColumn(value) {
      this._setOption('avgOtherColumn', value);
    }
    get count() {
      return this._getOption('count');
    }
    set count(value) {
      this._setOption('count', value);
    }
    get max() {
      return this._getOption('max');
    }
    set max(value) {
      this._setOption('max', value);
    }
    get maxOtherColumn() {
      return this._getOption('maxOtherColumn');
    }
    set maxOtherColumn(value) {
      this._setOption('maxOtherColumn', value);
    }
    get min() {
      return this._getOption('min');
    }
    set min(value) {
      this._setOption('min', value);
    }
    get minOtherColumn() {
      return this._getOption('minOtherColumn');
    }
    set minOtherColumn(value) {
      this._setOption('minOtherColumn', value);
    }
    get sum() {
      return this._getOption('sum');
    }
    set sum(value) {
      this._setOption('sum', value);
    }
    get sumOtherColumn() {
      return this._getOption('sumOtherColumn');
    }
    set sumOtherColumn(value) {
      this._setOption('sumOtherColumn', value);
    }
    get _optionPath() {
      return 'texts';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridSummaryTextsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridSummaryTextsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridSummaryTextsComponent,
      selectors: [["dxo-data-grid-summary-texts"]],
      inputs: {
        avg: "avg",
        avgOtherColumn: "avgOtherColumn",
        count: "count",
        max: "max",
        maxOtherColumn: "maxOtherColumn",
        min: "min",
        minOtherColumn: "minOtherColumn",
        sum: "sum",
        sumOtherColumn: "sumOtherColumn"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridSummaryTextsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridSummaryTextsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridSummaryTextsModule = /*#__PURE__*/(() => {
  class DxoDataGridSummaryTextsModule {
    /** @nocollapse */static ɵfac = function DxoDataGridSummaryTextsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridSummaryTextsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridSummaryTextsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridSummaryTextsComponent]
    });
  }
  return DxoDataGridSummaryTextsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridSummaryComponent = /*#__PURE__*/(() => {
  class DxoDataGridSummaryComponent extends NestedOption {
    set _groupItemsContentChildren(value) {
      this.setChildren('groupItems', value);
    }
    set _totalItemsContentChildren(value) {
      this.setChildren('totalItems', value);
    }
    get calculateCustomSummary() {
      return this._getOption('calculateCustomSummary');
    }
    set calculateCustomSummary(value) {
      this._setOption('calculateCustomSummary', value);
    }
    get groupItems() {
      return this._getOption('groupItems');
    }
    set groupItems(value) {
      this._setOption('groupItems', value);
    }
    get recalculateWhileEditing() {
      return this._getOption('recalculateWhileEditing');
    }
    set recalculateWhileEditing(value) {
      this._setOption('recalculateWhileEditing', value);
    }
    get skipEmptyValues() {
      return this._getOption('skipEmptyValues');
    }
    set skipEmptyValues(value) {
      this._setOption('skipEmptyValues', value);
    }
    get texts() {
      return this._getOption('texts');
    }
    set texts(value) {
      this._setOption('texts', value);
    }
    get totalItems() {
      return this._getOption('totalItems');
    }
    set totalItems(value) {
      this._setOption('totalItems', value);
    }
    get _optionPath() {
      return 'summary';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridSummaryComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridSummaryComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridSummaryComponent,
      selectors: [["dxo-data-grid-summary"]],
      contentQueries: function DxoDataGridSummaryComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_groupItems, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_totalItems, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._groupItemsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._totalItemsContentChildren = _t);
        }
      },
      inputs: {
        calculateCustomSummary: "calculateCustomSummary",
        groupItems: "groupItems",
        recalculateWhileEditing: "recalculateWhileEditing",
        skipEmptyValues: "skipEmptyValues",
        texts: "texts",
        totalItems: "totalItems"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridSummaryComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridSummaryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridSummaryModule = /*#__PURE__*/(() => {
  class DxoDataGridSummaryModule {
    /** @nocollapse */static ɵfac = function DxoDataGridSummaryModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridSummaryModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridSummaryModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridSummaryComponent]
    });
  }
  return DxoDataGridSummaryModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridTextsComponent = /*#__PURE__*/(() => {
  class DxoDataGridTextsComponent extends NestedOption {
    get addRow() {
      return this._getOption('addRow');
    }
    set addRow(value) {
      this._setOption('addRow', value);
    }
    get cancelAllChanges() {
      return this._getOption('cancelAllChanges');
    }
    set cancelAllChanges(value) {
      this._setOption('cancelAllChanges', value);
    }
    get cancelRowChanges() {
      return this._getOption('cancelRowChanges');
    }
    set cancelRowChanges(value) {
      this._setOption('cancelRowChanges', value);
    }
    get confirmDeleteMessage() {
      return this._getOption('confirmDeleteMessage');
    }
    set confirmDeleteMessage(value) {
      this._setOption('confirmDeleteMessage', value);
    }
    get confirmDeleteTitle() {
      return this._getOption('confirmDeleteTitle');
    }
    set confirmDeleteTitle(value) {
      this._setOption('confirmDeleteTitle', value);
    }
    get deleteRow() {
      return this._getOption('deleteRow');
    }
    set deleteRow(value) {
      this._setOption('deleteRow', value);
    }
    get editRow() {
      return this._getOption('editRow');
    }
    set editRow(value) {
      this._setOption('editRow', value);
    }
    get saveAllChanges() {
      return this._getOption('saveAllChanges');
    }
    set saveAllChanges(value) {
      this._setOption('saveAllChanges', value);
    }
    get saveRowChanges() {
      return this._getOption('saveRowChanges');
    }
    set saveRowChanges(value) {
      this._setOption('saveRowChanges', value);
    }
    get undeleteRow() {
      return this._getOption('undeleteRow');
    }
    set undeleteRow(value) {
      this._setOption('undeleteRow', value);
    }
    get validationCancelChanges() {
      return this._getOption('validationCancelChanges');
    }
    set validationCancelChanges(value) {
      this._setOption('validationCancelChanges', value);
    }
    get exportAll() {
      return this._getOption('exportAll');
    }
    set exportAll(value) {
      this._setOption('exportAll', value);
    }
    get exportSelectedRows() {
      return this._getOption('exportSelectedRows');
    }
    set exportSelectedRows(value) {
      this._setOption('exportSelectedRows', value);
    }
    get exportTo() {
      return this._getOption('exportTo');
    }
    set exportTo(value) {
      this._setOption('exportTo', value);
    }
    get groupByThisColumn() {
      return this._getOption('groupByThisColumn');
    }
    set groupByThisColumn(value) {
      this._setOption('groupByThisColumn', value);
    }
    get groupContinuedMessage() {
      return this._getOption('groupContinuedMessage');
    }
    set groupContinuedMessage(value) {
      this._setOption('groupContinuedMessage', value);
    }
    get groupContinuesMessage() {
      return this._getOption('groupContinuesMessage');
    }
    set groupContinuesMessage(value) {
      this._setOption('groupContinuesMessage', value);
    }
    get ungroup() {
      return this._getOption('ungroup');
    }
    set ungroup(value) {
      this._setOption('ungroup', value);
    }
    get ungroupAll() {
      return this._getOption('ungroupAll');
    }
    set ungroupAll(value) {
      this._setOption('ungroupAll', value);
    }
    get avg() {
      return this._getOption('avg');
    }
    set avg(value) {
      this._setOption('avg', value);
    }
    get avgOtherColumn() {
      return this._getOption('avgOtherColumn');
    }
    set avgOtherColumn(value) {
      this._setOption('avgOtherColumn', value);
    }
    get count() {
      return this._getOption('count');
    }
    set count(value) {
      this._setOption('count', value);
    }
    get max() {
      return this._getOption('max');
    }
    set max(value) {
      this._setOption('max', value);
    }
    get maxOtherColumn() {
      return this._getOption('maxOtherColumn');
    }
    set maxOtherColumn(value) {
      this._setOption('maxOtherColumn', value);
    }
    get min() {
      return this._getOption('min');
    }
    set min(value) {
      this._setOption('min', value);
    }
    get minOtherColumn() {
      return this._getOption('minOtherColumn');
    }
    set minOtherColumn(value) {
      this._setOption('minOtherColumn', value);
    }
    get sum() {
      return this._getOption('sum');
    }
    set sum(value) {
      this._setOption('sum', value);
    }
    get sumOtherColumn() {
      return this._getOption('sumOtherColumn');
    }
    set sumOtherColumn(value) {
      this._setOption('sumOtherColumn', value);
    }
    get fix() {
      return this._getOption('fix');
    }
    set fix(value) {
      this._setOption('fix', value);
    }
    get leftPosition() {
      return this._getOption('leftPosition');
    }
    set leftPosition(value) {
      this._setOption('leftPosition', value);
    }
    get rightPosition() {
      return this._getOption('rightPosition');
    }
    set rightPosition(value) {
      this._setOption('rightPosition', value);
    }
    get stickyPosition() {
      return this._getOption('stickyPosition');
    }
    set stickyPosition(value) {
      this._setOption('stickyPosition', value);
    }
    get unfix() {
      return this._getOption('unfix');
    }
    set unfix(value) {
      this._setOption('unfix', value);
    }
    get clearFilter() {
      return this._getOption('clearFilter');
    }
    set clearFilter(value) {
      this._setOption('clearFilter', value);
    }
    get createFilter() {
      return this._getOption('createFilter');
    }
    set createFilter(value) {
      this._setOption('createFilter', value);
    }
    get filterEnabledHint() {
      return this._getOption('filterEnabledHint');
    }
    set filterEnabledHint(value) {
      this._setOption('filterEnabledHint', value);
    }
    get cancel() {
      return this._getOption('cancel');
    }
    set cancel(value) {
      this._setOption('cancel', value);
    }
    get emptyValue() {
      return this._getOption('emptyValue');
    }
    set emptyValue(value) {
      this._setOption('emptyValue', value);
    }
    get ok() {
      return this._getOption('ok');
    }
    set ok(value) {
      this._setOption('ok', value);
    }
    get _optionPath() {
      return 'texts';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridTextsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridTextsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridTextsComponent,
      selectors: [["dxo-data-grid-texts"]],
      inputs: {
        addRow: "addRow",
        cancelAllChanges: "cancelAllChanges",
        cancelRowChanges: "cancelRowChanges",
        confirmDeleteMessage: "confirmDeleteMessage",
        confirmDeleteTitle: "confirmDeleteTitle",
        deleteRow: "deleteRow",
        editRow: "editRow",
        saveAllChanges: "saveAllChanges",
        saveRowChanges: "saveRowChanges",
        undeleteRow: "undeleteRow",
        validationCancelChanges: "validationCancelChanges",
        exportAll: "exportAll",
        exportSelectedRows: "exportSelectedRows",
        exportTo: "exportTo",
        groupByThisColumn: "groupByThisColumn",
        groupContinuedMessage: "groupContinuedMessage",
        groupContinuesMessage: "groupContinuesMessage",
        ungroup: "ungroup",
        ungroupAll: "ungroupAll",
        avg: "avg",
        avgOtherColumn: "avgOtherColumn",
        count: "count",
        max: "max",
        maxOtherColumn: "maxOtherColumn",
        min: "min",
        minOtherColumn: "minOtherColumn",
        sum: "sum",
        sumOtherColumn: "sumOtherColumn",
        fix: "fix",
        leftPosition: "leftPosition",
        rightPosition: "rightPosition",
        stickyPosition: "stickyPosition",
        unfix: "unfix",
        clearFilter: "clearFilter",
        createFilter: "createFilter",
        filterEnabledHint: "filterEnabledHint",
        cancel: "cancel",
        emptyValue: "emptyValue",
        ok: "ok"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridTextsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridTextsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridTextsModule = /*#__PURE__*/(() => {
  class DxoDataGridTextsModule {
    /** @nocollapse */static ɵfac = function DxoDataGridTextsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridTextsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridTextsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridTextsComponent]
    });
  }
  return DxoDataGridTextsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridToComponent = /*#__PURE__*/(() => {
  class DxoDataGridToComponent extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get scale() {
      return this._getOption('scale');
    }
    set scale(value) {
      this._setOption('scale', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'to';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridToComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridToComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridToComponent,
      selectors: [["dxo-data-grid-to"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridToComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridToComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridToModule = /*#__PURE__*/(() => {
  class DxoDataGridToModule {
    /** @nocollapse */static ɵfac = function DxoDataGridToModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridToModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridToModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridToComponent]
    });
  }
  return DxoDataGridToModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridToolbarItemComponent = /*#__PURE__*/(() => {
  class DxiDataGridToolbarItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get locateInMenu() {
      return this._getOption('locateInMenu');
    }
    set locateInMenu(value) {
      this._setOption('locateInMenu', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get menuItemTemplate() {
      return this._getOption('menuItemTemplate');
    }
    set menuItemTemplate(value) {
      this._setOption('menuItemTemplate', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get showText() {
      return this._getOption('showText');
    }
    set showText(value) {
      this._setOption('showText', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get toolbar() {
      return this._getOption('toolbar');
    }
    set toolbar(value) {
      this._setOption('toolbar', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get widget() {
      return this._getOption('widget');
    }
    set widget(value) {
      this._setOption('widget', value);
    }
    get _optionPath() {
      return 'toolbarItems';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridToolbarItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridToolbarItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridToolbarItemComponent,
      selectors: [["dxi-data-grid-toolbar-item"]],
      inputs: {
        cssClass: "cssClass",
        disabled: "disabled",
        html: "html",
        locateInMenu: "locateInMenu",
        location: "location",
        menuItemTemplate: "menuItemTemplate",
        options: "options",
        showText: "showText",
        template: "template",
        text: "text",
        toolbar: "toolbar",
        visible: "visible",
        widget: "widget"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_toolbarItems,
        useExisting: DxiDataGridToolbarItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiDataGridToolbarItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiDataGridToolbarItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridToolbarItemModule = /*#__PURE__*/(() => {
  class DxiDataGridToolbarItemModule {
    /** @nocollapse */static ɵfac = function DxiDataGridToolbarItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridToolbarItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridToolbarItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridToolbarItemComponent]
    });
  }
  return DxiDataGridToolbarItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridToolbarComponent = /*#__PURE__*/(() => {
  class DxoDataGridToolbarComponent extends NestedOption {
    set _itemsContentChildren(value) {
      this.setChildren('items', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'toolbar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridToolbarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridToolbarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridToolbarComponent,
      selectors: [["dxo-data-grid-toolbar"]],
      contentQueries: function DxoDataGridToolbarComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_items, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._itemsContentChildren = _t);
        }
      },
      inputs: {
        disabled: "disabled",
        items: "items",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridToolbarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridToolbarModule = /*#__PURE__*/(() => {
  class DxoDataGridToolbarModule {
    /** @nocollapse */static ɵfac = function DxoDataGridToolbarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridToolbarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridToolbarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridToolbarComponent]
    });
  }
  return DxoDataGridToolbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridTotalItemComponent = /*#__PURE__*/(() => {
  class DxiDataGridTotalItemComponent extends CollectionNestedOption {
    get alignment() {
      return this._getOption('alignment');
    }
    set alignment(value) {
      this._setOption('alignment', value);
    }
    get column() {
      return this._getOption('column');
    }
    set column(value) {
      this._setOption('column', value);
    }
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get displayFormat() {
      return this._getOption('displayFormat');
    }
    set displayFormat(value) {
      this._setOption('displayFormat', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get showInColumn() {
      return this._getOption('showInColumn');
    }
    set showInColumn(value) {
      this._setOption('showInColumn', value);
    }
    get skipEmptyValues() {
      return this._getOption('skipEmptyValues');
    }
    set skipEmptyValues(value) {
      this._setOption('skipEmptyValues', value);
    }
    get summaryType() {
      return this._getOption('summaryType');
    }
    set summaryType(value) {
      this._setOption('summaryType', value);
    }
    get valueFormat() {
      return this._getOption('valueFormat');
    }
    set valueFormat(value) {
      this._setOption('valueFormat', value);
    }
    get _optionPath() {
      return 'totalItems';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridTotalItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridTotalItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridTotalItemComponent,
      selectors: [["dxi-data-grid-total-item"]],
      inputs: {
        alignment: "alignment",
        column: "column",
        cssClass: "cssClass",
        customizeText: "customizeText",
        displayFormat: "displayFormat",
        name: "name",
        showInColumn: "showInColumn",
        skipEmptyValues: "skipEmptyValues",
        summaryType: "summaryType",
        valueFormat: "valueFormat"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_totalItems,
        useExisting: DxiDataGridTotalItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridTotalItemComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridTotalItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridTotalItemModule = /*#__PURE__*/(() => {
  class DxiDataGridTotalItemModule {
    /** @nocollapse */static ɵfac = function DxiDataGridTotalItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridTotalItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridTotalItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridTotalItemComponent]
    });
  }
  return DxiDataGridTotalItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDataGridValidationRuleComponent = /*#__PURE__*/(() => {
  class DxiDataGridValidationRuleComponent extends CollectionNestedOption {
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get trim() {
      return this._getOption('trim');
    }
    set trim(value) {
      this._setOption('trim', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get max() {
      return this._getOption('max');
    }
    set max(value) {
      this._setOption('max', value);
    }
    get min() {
      return this._getOption('min');
    }
    set min(value) {
      this._setOption('min', value);
    }
    get reevaluate() {
      return this._getOption('reevaluate');
    }
    set reevaluate(value) {
      this._setOption('reevaluate', value);
    }
    get validationCallback() {
      return this._getOption('validationCallback');
    }
    set validationCallback(value) {
      this._setOption('validationCallback', value);
    }
    get comparisonTarget() {
      return this._getOption('comparisonTarget');
    }
    set comparisonTarget(value) {
      this._setOption('comparisonTarget', value);
    }
    get comparisonType() {
      return this._getOption('comparisonType');
    }
    set comparisonType(value) {
      this._setOption('comparisonType', value);
    }
    get pattern() {
      return this._getOption('pattern');
    }
    set pattern(value) {
      this._setOption('pattern', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'required';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDataGridValidationRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridValidationRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDataGridValidationRuleComponent,
      selectors: [["dxi-data-grid-validation-rule"]],
      inputs: {
        message: "message",
        trim: "trim",
        type: "type",
        ignoreEmptyValue: "ignoreEmptyValue",
        max: "max",
        min: "min",
        reevaluate: "reevaluate",
        validationCallback: "validationCallback",
        comparisonTarget: "comparisonTarget",
        comparisonType: "comparisonType",
        pattern: "pattern"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiDataGridValidationRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiDataGridValidationRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiDataGridValidationRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDataGridValidationRuleModule = /*#__PURE__*/(() => {
  class DxiDataGridValidationRuleModule {
    /** @nocollapse */static ɵfac = function DxiDataGridValidationRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDataGridValidationRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDataGridValidationRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDataGridValidationRuleComponent]
    });
  }
  return DxiDataGridValidationRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDataGridValueFormatComponent = /*#__PURE__*/(() => {
  class DxoDataGridValueFormatComponent extends NestedOption {
    get currency() {
      return this._getOption('currency');
    }
    set currency(value) {
      this._setOption('currency', value);
    }
    get formatter() {
      return this._getOption('formatter');
    }
    set formatter(value) {
      this._setOption('formatter', value);
    }
    get parser() {
      return this._getOption('parser');
    }
    set parser(value) {
      this._setOption('parser', value);
    }
    get precision() {
      return this._getOption('precision');
    }
    set precision(value) {
      this._setOption('precision', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useCurrencyAccountingStyle() {
      return this._getOption('useCurrencyAccountingStyle');
    }
    set useCurrencyAccountingStyle(value) {
      this._setOption('useCurrencyAccountingStyle', value);
    }
    get _optionPath() {
      return 'valueFormat';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDataGridValueFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridValueFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDataGridValueFormatComponent,
      selectors: [["dxo-data-grid-value-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDataGridValueFormatComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDataGridValueFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDataGridValueFormatModule = /*#__PURE__*/(() => {
  class DxoDataGridValueFormatModule {
    /** @nocollapse */static ɵfac = function DxoDataGridValueFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDataGridValueFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDataGridValueFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDataGridValueFormatComponent]
    });
  }
  return DxoDataGridValueFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiDataGridAsyncRuleComponent, DxiDataGridAsyncRuleModule, DxiDataGridButtonComponent, DxiDataGridButtonModule, DxiDataGridChangeComponent, DxiDataGridChangeModule, DxiDataGridColumnComponent, DxiDataGridColumnModule, DxiDataGridCompareRuleComponent, DxiDataGridCompareRuleModule, DxiDataGridCustomOperationComponent, DxiDataGridCustomOperationModule, DxiDataGridCustomRuleComponent, DxiDataGridCustomRuleModule, DxiDataGridEmailRuleComponent, DxiDataGridEmailRuleModule, DxiDataGridFieldComponent, DxiDataGridFieldModule, DxiDataGridGroupItemComponent, DxiDataGridGroupItemModule, DxiDataGridItemComponent, DxiDataGridItemModule, DxiDataGridNumericRuleComponent, DxiDataGridNumericRuleModule, DxiDataGridPatternRuleComponent, DxiDataGridPatternRuleModule, DxiDataGridRangeRuleComponent, DxiDataGridRangeRuleModule, DxiDataGridRequiredRuleComponent, DxiDataGridRequiredRuleModule, DxiDataGridSortByGroupSummaryInfoComponent, DxiDataGridSortByGroupSummaryInfoModule, DxiDataGridStringLengthRuleComponent, DxiDataGridStringLengthRuleModule, DxiDataGridToolbarItemComponent, DxiDataGridToolbarItemModule, DxiDataGridTotalItemComponent, DxiDataGridTotalItemModule, DxiDataGridValidationRuleComponent, DxiDataGridValidationRuleModule, DxoDataGridAnimationComponent, DxoDataGridAnimationModule, DxoDataGridAtComponent, DxoDataGridAtModule, DxoDataGridBoundaryOffsetComponent, DxoDataGridBoundaryOffsetModule, DxoDataGridColCountByScreenComponent, DxoDataGridColCountByScreenModule, DxoDataGridCollisionComponent, DxoDataGridCollisionModule, DxoDataGridColumnChooserComponent, DxoDataGridColumnChooserModule, DxoDataGridColumnChooserSearchComponent, DxoDataGridColumnChooserSearchModule, DxoDataGridColumnChooserSelectionComponent, DxoDataGridColumnChooserSelectionModule, DxoDataGridColumnFixingComponent, DxoDataGridColumnFixingModule, DxoDataGridColumnFixingTextsComponent, DxoDataGridColumnFixingTextsModule, DxoDataGridColumnHeaderFilterComponent, DxoDataGridColumnHeaderFilterModule, DxoDataGridColumnHeaderFilterSearchComponent, DxoDataGridColumnHeaderFilterSearchModule, DxoDataGridColumnLookupComponent, DxoDataGridColumnLookupModule, DxoDataGridCursorOffsetComponent, DxoDataGridCursorOffsetModule, DxoDataGridDataGridHeaderFilterComponent, DxoDataGridDataGridHeaderFilterModule, DxoDataGridDataGridHeaderFilterSearchComponent, DxoDataGridDataGridHeaderFilterSearchModule, DxoDataGridDataGridHeaderFilterTextsComponent, DxoDataGridDataGridHeaderFilterTextsModule, DxoDataGridDataGridSelectionComponent, DxoDataGridDataGridSelectionModule, DxoDataGridEditingComponent, DxoDataGridEditingModule, DxoDataGridEditingTextsComponent, DxoDataGridEditingTextsModule, DxoDataGridExportComponent, DxoDataGridExportModule, DxoDataGridExportTextsComponent, DxoDataGridExportTextsModule, DxoDataGridFieldLookupComponent, DxoDataGridFieldLookupModule, DxoDataGridFilterBuilderComponent, DxoDataGridFilterBuilderModule, DxoDataGridFilterBuilderPopupComponent, DxoDataGridFilterBuilderPopupModule, DxoDataGridFilterOperationDescriptionsComponent, DxoDataGridFilterOperationDescriptionsModule, DxoDataGridFilterPanelComponent, DxoDataGridFilterPanelModule, DxoDataGridFilterPanelTextsComponent, DxoDataGridFilterPanelTextsModule, DxoDataGridFilterRowComponent, DxoDataGridFilterRowModule, DxoDataGridFormComponent, DxoDataGridFormItemComponent, DxoDataGridFormItemModule, DxoDataGridFormModule, DxoDataGridFormatComponent, DxoDataGridFormatModule, DxoDataGridFromComponent, DxoDataGridFromModule, DxoDataGridGroupOperationDescriptionsComponent, DxoDataGridGroupOperationDescriptionsModule, DxoDataGridGroupPanelComponent, DxoDataGridGroupPanelModule, DxoDataGridGroupingComponent, DxoDataGridGroupingModule, DxoDataGridGroupingTextsComponent, DxoDataGridGroupingTextsModule, DxoDataGridHeaderFilterComponent, DxoDataGridHeaderFilterModule, DxoDataGridHideComponent, DxoDataGridHideModule, DxoDataGridIconsComponent, DxoDataGridIconsModule, DxoDataGridKeyboardNavigationComponent, DxoDataGridKeyboardNavigationModule, DxoDataGridLabelComponent, DxoDataGridLabelModule, DxoDataGridLoadPanelComponent, DxoDataGridLoadPanelModule, DxoDataGridLookupComponent, DxoDataGridLookupModule, DxoDataGridMasterDetailComponent, DxoDataGridMasterDetailModule, DxoDataGridMyComponent, DxoDataGridMyModule, DxoDataGridOffsetComponent, DxoDataGridOffsetModule, DxoDataGridOperationDescriptionsComponent, DxoDataGridOperationDescriptionsModule, DxoDataGridPagerComponent, DxoDataGridPagerModule, DxoDataGridPagingComponent, DxoDataGridPagingModule, DxoDataGridPopupComponent, DxoDataGridPopupModule, DxoDataGridPositionComponent, DxoDataGridPositionModule, DxoDataGridRemoteOperationsComponent, DxoDataGridRemoteOperationsModule, DxoDataGridRowDraggingComponent, DxoDataGridRowDraggingModule, DxoDataGridScrollingComponent, DxoDataGridScrollingModule, DxoDataGridSearchComponent, DxoDataGridSearchModule, DxoDataGridSearchPanelComponent, DxoDataGridSearchPanelModule, DxoDataGridSelectionComponent, DxoDataGridSelectionModule, DxoDataGridShowComponent, DxoDataGridShowModule, DxoDataGridSortingComponent, DxoDataGridSortingModule, DxoDataGridStateStoringComponent, DxoDataGridStateStoringModule, DxoDataGridSummaryComponent, DxoDataGridSummaryModule, DxoDataGridSummaryTextsComponent, DxoDataGridSummaryTextsModule, DxoDataGridTextsComponent, DxoDataGridTextsModule, DxoDataGridToComponent, DxoDataGridToModule, DxoDataGridToolbarComponent, DxoDataGridToolbarModule, DxoDataGridValueFormatComponent, DxoDataGridValueFormatModule };
